/***

**Module Name: client
 **File Name :  client.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains clients table details.
 ***/
import React, { useState, useEffect, useContext, useRef } from "react";


import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import tmdbApi from "../../api/tmdbApi";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from 'axios';
import SweetAlert from 'react-bootstrap-sweetalert';
import Modal from 'react-bootstrap/Modal';
import moment from "moment";
import SessionPopup from "../SessionPopup"
import Loader from "../../components/loader";
import Tooltip from '@mui/material/Tooltip'
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import TableLoader from "../../components/tableLoader";
import { contentContext } from "../../context/contentContext";
import DataTable from 'react-data-table-component';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

let { lambda, appname } = window.app;


const AllLeads = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    // const [toggle, setToggle] = useState(false);
    const [deals, setDeals] = useState("");
    const [perpage, setPerpage] = useState(10);
    const [success, setSuccess] = useState(false);
    const [success2, setSuccess2] = useState(false);

    const [sentMail, setSentEmail] = useState(false)
    const [image, setImg] = useState('');
    const [advSearchPopup, setAdvSearchPopup] = useState(false);
    const [loaderEnable, setLoaderEnable] = useState(false);
    const [advSearch, setAdvSearch] = useState({});
    const [isdelete, setDelete] = useState(false);
    const [item, setItem] = useState("");
    const [showConvDeleteModal, setShowConvDeleteModal] = useState(false);
    const [deleteConversationId, setDeleteConversationId] = useState("");
    const [contactSearchVal, setContactSearchVal] = useState("");
    const [convSearchVal, setConvSearchVal] = useState("");
    const [contactSearchActive, setContactSearchActive] = useState(false);
    const [convSearchEmptyActive, setConvSearchEmptyActive] = useState(false);
    const contactSearchRef = useRef("");
    const convSearchRef = useRef("");

    const [clientData, setClientData] = useState([])
    const [phonenumber, setPhoneNumber] = useState("");
    const [sortOrder, setSortOrder] = useState("ascending");

    const [totalCount, setTotalCount] = useState("")
    const [data, setData] = useState([]);
    const [idc, setIdc] = useState("");

    const [buyerdata, setBuyerData] = useState([]);
    const [countries, setCountries] = useState('');
    const [account, setAccount] = useState([]);
    const [previousEmail, setPreviousEmail] = useState('');
    //const [currentPage, setcurrentPage] = useState(1);
    const [exportLoad, setExportLoad] = useState(false);
    const [currentPageExport, setCurrentPageEport] = useState(1);
    const [activeCheckId, setActiveCheckId] = useState("");

    const [rowsPerPageExport, setRowsPerPageExport] = useState(15);

    const [dealsmsg, setDealsMsg] = useState("");
    const [isChecked1, setIsChecked1] = useState(false);
    const [btnLoader, setBtnLoader] = useState("");
    const [totalLeads, setTotalLeads] = useState("")
    // const [isLoading, setIsLoading] = useState(false);
    const [flag, setFlag] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);

    const [company, setCompany] = useState([]);
    // const [paginationnumber, setPagintionNumber] = useState({});

    const [popup, setShowPopup] = useState(false);
    const [showExists, setShowExists] = useState(false);
    const [addPopup, setAddPopup] = useState(false);
    const [conversationpopup, setConversationpopup] = useState(false);

    const [adminPopup, setAdminPopup] = useState(false);
    const handleClosePopup = () => setAdvSearchPopup(false);

    const handleCloseConversation = () => setConversationpopup(false)
    const handleCloseAddPopup = () => setAddPopup(false);
    const handleCloseAdminPopup = () => setAdminPopup(false);
    const [sortDirection, setSortDirection] = useState('asc');
    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum] = useState();
    const [tableErrMsg, setTableErrMsg] = useState(false);
    const [clientPopup, setClientPopup] = useState(false);
    const [assignAcm, setAssignAcm] = useState(null);

    const [leadError, setLeadError] = useState({});

    const [exportData, setExportData] = useState([]);
    const [exportFlag, setExportFlag] = useState(true);

    const [loaderDelete, setLoaderDelete] = useState(false);

    const { searchedFlag, activeSearch, setActiveSearch, setActiveMenuObj, addComments, flagg, setFlagg, setAddComments, leadSearch, setLeadSearch, clearIcon, setClearIcon, content, setContent, saveLeadId, setSaveLeadId, updateLead, setUpdateLead, activeconversationItem, leadsFormData, setLeadsFormData, addClientData, setAddClientData, filterLeads, setFilterLeads, setActiveconversationItem, tempLeadList, setTempLeadList, setSearchedFlag, isChecked, setIsChecked, conversationFormData, leadData, setLeadData, setConversationFormData, conversationData, setConversationData, allLeadsData, setAllLeadsData, isLoading, setNavigateToggle, setIsLoading, processObject, sortTableAlpha, arrow, sortTableByDate, userData, dealsearch, setDealSearch, dealsadvSearch, setDealsAdvSearch, currentPage, setcurrentPage, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)

    const [notifyData, setNotifyData] = useState({})

    // var exportExcelData = ["kiran"]
    const [activeExportBtn, setActiveExportBtn] = useState(false);

    const prevRoute = usePrevious(route)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "Contact Management")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].submenus && validateObj[0].submenus[1].dashboard
    useEffect(() => {
        if (prevRoute != undefined && prevRoute != route) {
            setCurrentPage(1)
            setRowsPerPage(15)
            setDealsAdvSearch({})
            setSearchedFlag(false);
            setDealSearch("")


        }



    }, [prevRoute]);
    const columnsExport = [
        {
            name: 'File',
            selector: row => row?.exportId ?? "",
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => (
                row.status === "Inprogress" ? (
                    <>
                        <label>Inprogress</label>
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped bg-info" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                    </>
                ) : (
                    row.status
                )
            ),
            sortable: true,
        },
        {
            name: 'Created',
            selector: row => row?.created,
            cell: props => props?.created ? new Date(props.created).toLocaleDateString('en-IN', {
                day: '2-digit',
                month: '2-digit',
                year: '2-digit',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
            }) : '',
            sortable: true,
        },
        {
            name: 'Completed on',
            selector: row => row?.completedOn,
            cell: props => props?.completedOn ? new Date(props.completedOn).toLocaleDateString('en-IN', {
                day: '2-digit',
                month: '2-digit',
                year: '2-digit',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
            }) : '',
            sortable: true,
        },
        {
            name: 'Type',
            selector: row => row?.type,
            sortable: true,
        },
        {
            name: 'Actions',
            cell: props => (
                <div className="d-flex">
                    {props.status === "Inprogress" ? (
                        <a className="text-success action-button" onClick={e => handleRefresh(e, props)}>
                            <span className="material-icons-outlined text-warning">
                                {activeCheckId === props.exportId ? (
                                    <img src="https://d9nwtjplhevo0.cloudfront.net/orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg" className="loading-icon" />
                                ) : (
                                    <span className="material-icons-outlined">refresh</span>
                                )}
                            </span>
                        </a>
                    ) : (
                        //  <a href={`${window?.site?.common?.proxiesCloudFront}/${props.downloadLink}`} className="text-success action-button" download>
                        //      <span className="material-icons-outlined text-success">download</span>
                        //  </a>


                        <button className="text-success action-button">
                            <span
                                className="material-icons-outlined"
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleDownload(`${window?.site?.common?.proxiesCloudFront}/${props.downloadLink}`, props)}
                            >
                                download
                            </span>
                        </button>
                    )}
                    <a className="text-danger action-button" onClick={e => handleDeleteExportFilePopup(e, props.exportId)}>
                        <span className="material-icons-outlined">delete_outline</span>
                    </a>
                </div>
            ),
        },
    ];


    const handleDeleteExportFile = (e) => {
        let userid = localStorage.getItem("userId");
        const token = localStorage.getItem("token")
        const id = item
        setLoaderDelete(true)
        axios({
            method: 'DELETE',
            url: lambda + '/deleteLeadExports?appname=' + appname + "&exportid=" + id + "&userid=" + userid + "&token=" + token,
        })
            .then(function (response) {
                if (response) {
                    if (response?.result == "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {

                        fetchExportData();
                        setSuccess2(true)
                    }
                    setLoaderDelete(false)
                    setDelete(false)

                }
            });
    }


    const handleDeleteExportFilePopup = (e, fileid) => {
        setDelete(true);
        setItem(fileid);
    }


    function onCancel() {
        setDelete(false)
    }

    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imagesCDN) {
                    setImg(window.site.common.imagesCDN)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imagesCDN) {
            setImg(window.site.common.imagesCDN)
        }

    }, [window.site]);

    const keyForRerender = `${rowsPerPage}_${data?.length}`;
    const handleRefresh = (e, item) => {
        setActiveCheckId(item.exportId)
        const token = localStorage.getItem("token")
        let userid = localStorage.getItem("userId");
        let exportId = item.exportId
        axios({
            method: 'POST',
            url: lambda + '/fetchLeadExports?appname=' + appname + "&userid=" + userid + "&source=content" + "&token=" + token + "&exportid=" + exportId
        })
            .then(function (response) {
                if (response) {
                    if (response?.data?.result == "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {
                        console.log('response----------------->', response)


                        const updatedRecord = response?.data?.result && response?.data?.result?.[0];

                        const updatedData1 = exportData.map((record) => {
                            if (record.exportId === exportId) {
                                return { ...record, ...updatedRecord };
                            }
                            return record;
                        });

                        console.log('updatedData', updatedData1)

                        setExportData(updatedData1);
                    }
                    setActiveCheckId("")
                }
                setActiveCheckId("")

            });
    };
    const GetCountries = async () => {
        try {

            const response = await tmdbApi.getLookUp({
                "type": ["country"],
                "sortBy": "alpha3",
                "projection": "tiny"
            });

            if (response?.result?.data == "Invalid token or Expired") {
                setShowSessionPopupup(true)
            } else {
                setCountries(response?.result?.data);
            }
        } catch {
        }
    };

    const columns = [

        {
            name: 'Name',
            selector: row => row?.clientname ?? "",
            sortable: true,
        },

        {
            name: 'Type',
            cell: (props) => <button type="button" className="btn btn-primary btn-sm btn-rounded " data-bs-toggle="modal" data-bs-target=".orderdetailsModal">
                {props?.clienttype === "BUYER" ? <span className="material-icons-outlined text-primary"> local_mall</span> : props?.clienttype === "SELLER" ? <span className="material-icons-outlined text-danger"> storefront</span> : <span className="material-icons-outlined text-success"> group </span>}
                {props?.clienttype}
            </button>,
            sortable: false,
        },
        {
            name: 'Account manager',
            selector: row => row?.accountmanager ?? "",
            sortable: true,
        },
        {
            name: 'Enquired On',
            // selector: row => moment(row.created).utc().format("DD-MMM-YYYY HH:mm"),
            selector: row => row?.created,
            cell: (props) => props?.created != undefined ? new Date(props?.created).toLocaleDateString('en-IN', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
            }) : '',
            sortable: true,
            // sortFunction: (a, b) => moment(a.created).diff(b.created),
        },
        {
            name: 'Followed On',
            // selector: row => moment(row.updated).utc().format("DD-MMM-YYYY HH:mm"),
            selector: row => row.updated,
            cell: (props) => props.updated != undefined ? new Date(props.updated).toLocaleDateString('en-IN', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
            }) : '',
            sortable: true,
            // sortFunction: (a, b) => moment(a.updated).diff(b.updated),
        },
        {
            name: 'Comments',
            // selector: row => row?.comments ?? '',
            cell: (props) => <Tooltip title={props?.comments} placement="top"><div className="text-elipsis">{props?.comments ?? ""}</div></Tooltip>,
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row?.status ?? "",
            sortable: true,
        },


        {
            name: <>{(subValDashboard && subValDashboard.view && subValDashboard.view.display === true) || (subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true) ? 'Actions' : null}</>,
            cell: (props) =>
                //   {
                subValDashboard && subValDashboard.view && subValDashboard.view.display === true &&

                <div className="d-flex">
                    {subValDashboard && subValDashboard.view && subValDashboard.view.display === true &&
                        <a onClick={e => handleViewDeal(e, props.enquiryid)} className={`${subValDashboard && subValDashboard.view && subValDashboard.view.enable === false || tempLeadList?.length <= 0 || (userData?.userid !== leadData?.userid && userData?.type !== "ADMIN") ? 'pe-none' : ''} text-success action-button`}><i className="mdi mdi-eye font-size-18"></i></a>}
                    {subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true &&
                        <a onClick={e => handleEditDeal(e, props.enquiryid)} className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false || tempLeadList?.length <= 0 || (userData?.userid !== leadData?.userid && userData?.type !== "ADMIN") ? 'pe-none' : ''} text-danger action-button`}><i className="mdi mdi-pencil font-size-18"></i></a>}
                </div>

            //  }
            ,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];
    const handlePageChange = (page) => {
        GetTimeActivity()
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage) => {
        GetTimeActivity()
        setRowsPerPage(newPerPage);
    };
    const notify = () => {
        toast.success('Sent email', {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }
    const handleShowPopup = () => {
        GetTimeActivity()
        setShowPopup(true);
    };
    const GetCompany = () => {
        GetTimeActivity()
        const token = localStorage.getItem("token")
        const userid = localStorage.getItem("userId")
        axios({
            method: 'get',
            url: lambda + '/companylist?appname=' + appname + "&token=" + token + '&userid=' + userid + "&page=" + "leads",
        })
            .then(function (response) {
                if (response?.data?.result == "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    // console.log("response", response?.data?.result);
                    setCompany(response?.data?.result?.data);

                }

            });
    }
    const handleExport1 = (data1) => {
        // let k = defaultData || exportExcelData
        // let k = exportExcelData
        const modifiedArray = global.exportExcelData.map((each, i) => ({
            "S.NO": i + 1,
            "NAME": each?.clientname ?? "",
            "TYPE": each?.clienttype ?? "",
            "ACCOUNT MANAGER": each?.accountmanager ?? "",
            "ENQUIRED ON": each?.created ? new Date(each?.created).toLocaleDateString('en-IN', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',

            }) : "",

            "FOLLOWED ON": each?.updated ? new Date(each?.updated).toLocaleDateString('en-IN', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',

            }) : "",
            "COMMENTS": each?.comments ?? "",
            "STATUS": each?.status ?? "",



            // "STATUS": status,
        }));

        exportToExcel(modifiedArray, "data");

    }
    function exportToExcel(jsonData, fileName) {
        delete jsonData['_id'];
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data1 = new Blob([excelBuffer], { type: 'application/octet-stream' });
        //FileSaver.saveAs(data, `${fileName}.xlsx`);
        FileSaver.saveAs(data1, `DealsData.xlsx`);
    }
    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            const aField = String(selector(rowA)).toLowerCase();
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // Log the sorted data to the // console
        // setSortedRecomData(sortedData)
        global.exportExcelData = sortedData


        return sortedData;
    };
    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setActiveMenuId(300012)
        setActiveMenuObj({
            "Contact Management": true,
            "Client Management": false,
            "Reports": false
        })
        setRoute("leads")
        GetCountries();
        setNavigateToggle("")

        getBuyerList();
        GetCompany()
        getAccount();
        getAllLeadsData()

        userActivity();
    }, []);

    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        var presentTime = moment();
        let payload;
        setIsLoading(true)
        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)

                }
            });
    }
    const handleChangeMultiSelect = (selected, key) => {

        GetTimeActivity()

        let newContent = Object.assign({}, conversationFormData);
        // setConversationFormData({ ...newContent, [key]: selected });
        setConversationFormData({
            ...newContent,
            [key]: selected || [],
        })
    }


    const handleChangeEmail = (selected, key) => {
        GetTimeActivity()


        let newContent = Object.assign({}, leadsFormData);
        console.log("selected", selected)
        setLeadsFormData({
            ...newContent,
            emailid: selected.value,
            phone: selected.phone ?? leadsFormData.phone,
            companyname: selected.companyname ?? leadsFormData.companyname,
            idc: selected.phone || selected.phone === "" ? (selected.phone.length > 0 ? selected.idc : '') : leadsFormData.idc,
            leadname: selected.name ?? leadsFormData.leadname,
            accountmanager: userData?.type === "ACCOUNTMANAGER" ? userData?.name : (selected.accountmanager ?? "")

        });



    }
    console.log("leadsFormData----->", leadsFormData)
    const handleChangeCompanySelect = (selected) => {
        let newContent = Object.assign({}, addClientData);
        setAddClientData({
            ...newContent,

            companyname: selected.value ?? addClientData.companyname,

        });
    }
    const handleRemoveCompanyError = () => {
        setLeadError({})
    }
    const handleRemoveError = () => {
        setLeadError({})
    }
    useEffect(() => {
        if (searchedFlag) {
            handleSearch();
        }
    }, [searchedFlag]);

    const getAllDeals = async (clientId) => {
        GetTimeActivity()
        setIsLoading(true)
        const token = localStorage.getItem("token")


        const linkUrl = `${lambda}/clientenquiry?appname=${appname}&userid=${localStorage.getItem("userId")}&token=${token}&clientid=${clientId}`;
        const payload = {
            clientid: clientId
        }
        axios({
            method: 'POST',
            url: linkUrl,
            data: payload
        })
            .then(function (response) {

                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {



                    if (response?.data?.result?.data?.length > 0) {
                        setData(response?.data?.result?.data);

                    } else {
                        setData([])
                    }
                    setTotalCount(response?.data?.result)

                    // global.exportExcelData = response?.data?.result?.data
                    setIsLoading(false)

                    setDeals(response?.data?.result);

                    setDealSearch("");
                    setSearchedFlag(false);

                }
            }).catch((err) => {
                setTableErrMsg(true)
                setIsLoading(false);
            });

    };

    const getBuyerList = (update) => {

        GetTimeActivity()
        const token = localStorage.getItem("token")
        const userid = localStorage.getItem("userId")
        axios({
            method: 'GET',
            url: lambda + '/clientType?appname=' + appname + "&token=" + token + '&userId=' + userid,
        })
            .then(function (response) {

                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    if (userData?.type === "ACCOUNTMANAGER") {

                        const data = response?.data?.result?.data?.filter((item) =>
                            item.companyData?.[0]?.accountmanager ? item.companyData?.[0]?.accountmanager === userData?.name : item?.accountmanager === userData?.name
                        );
                        setBuyerData(data);

                        console.log("data----------------->", data)


                    } else if (userData?.type === "MANAGER") {

                        setBuyerData(response?.data?.result?.data);
                    }
                    else {
                        setBuyerData(response?.data?.result?.data);

                    }


                }

            });
    }

    console.log("leadsFormData------------->", leadsFormData)

    const handleEditDeal = (e, id) => {
        GetTimeActivity()
        navigate("/editdeals/" + id);
    }

    const handleViewDeal = (e, id) => {
        GetTimeActivity()
        navigate("/viewdeals/" + id);
    }

    const handleSearch = (e, flagggg) => {
        GetTimeActivity()


        // if (flagggg === "normalsearch" || flagggg === "click") {
        //     setSearchedFlag(true)
        // }


        if (advSearch === "" && advSearch.length <= 0) {
            getAllLeadsData();
        }
        else {
            setLoaderEnable(true)
            const token = localStorage.getItem("token")
            let urlLink;

            urlLink = lambda + '/leads?appname=' + appname + "&userid=" + localStorage.getItem("userId")

            const result = processObject(advSearch);
            setDealsAdvSearch(result)
            contactSearchRef.current = "";
            setContactSearchVal("");
            axios({
                method: 'POST',
                url: urlLink,
                data: result,
            })
                .then(function (response) {
                    if (response?.data?.result == "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                        setShowPopup(false)
                        setLoaderEnable(false)
                    } else {
                        const resultData = response?.data?.result?.data ?? [];
                        setFlag(true)
                        setTempLeadList(resultData);
                        setTotalLeads(response?.data?.result?.totalleads)
                        global.exportExcelData = resultData
                        setAdvSearchPopup(false)
                        setLoaderEnable(false);
                        if (flagggg === "click") {
                            setDealSearch("")
                        }

                        if (resultData.length > 0) {
                            setContactSearchActive(false);
                            setConvSearchEmptyActive(false);
                            setAllLeadsData(resultData);
                            activateFirstSearchResult(resultData[0]);
                        } else {
                            setAllLeadsData([]);
                            setContactSearchActive(true);
                            setConvSearchEmptyActive(false);
                            setConversationData([]);
                        }
                    }
                }).catch((err) => {

                    setTableErrMsg(true)

                });
        }
    }
    const handleReset = () => {
        setAdvSearch({ contactName: "", company: "", accountManager: "", created: "", phone: "", email: "", status: "" });
    }
    const handleChange = (e) => {

        const onlyDigits = e.target.value.replace(/\D/g, "")
        // let errors = { ...leadError }
        // errors[e.target.name] = "";
        if (e.target.name === "phone") {
            setLeadsFormData({ ...leadsFormData, phone: onlyDigits })
            // setLeadError(prevErrors => ({
            //     ...prevErrors,
            //     idc: "",
            // }));
        }
        setAdvSearch({ ...advSearch, [e.target.name]: e.target.value });
    }
    console.log("advSearchhhhhhhhhhhhhhhh", advSearch)
    function onConfirm() {
        GetTimeActivity()
        setSuccess(false);
        setDealSearch("")
    };

    function onConfirmUpdate() {
        GetTimeActivity()
        setUpdateLead(false)
    }
    function onConfirm1() {
        GetTimeActivity()
        setShowExists(false);
    };
    const handleAddDeal = (e) => {
        GetTimeActivity()
        setLeadError({})

        navigate("/createdeal")
    }
    const handleAddLead = () => {
        GetTimeActivity()
        setAddPopup(true)
        if (userData?.type === "ACCOUNTMANAGER") {
            setIsChecked1(true)
            setLeadsFormData({ leadname: "", enquirydate: "", phone: "", idc: "", leadclassification: "", emailid: "", companyname: [""], contactdate: "", accountmanager: userData?.name })
        } else {
            setIsChecked1(false)
            setLeadsFormData({ leadname: "", enquirydate: "", phone: "", idc: "", leadclassification: "", emailid: "", companyname: [""], contactdate: "" })
        }
        setLeadError({})


    }
    const handleActiveIcon = (e) => {
        setActiveSearch(true)
        setClearIcon(true)
    }
    const handleCloseClient = () => {
        setClientPopup(false)
        setAddClientData({})
        setLeadError({})
    };
    const handlAddConversation = (e) => {
        setConversationFormData({ subject: "", leadclassification: "", enquirydate: "", contactdate: "", modeofcommunication: "", additionalcontacts: [], conversationsummary: "" })
        setConversationpopup(true)
        setLeadError({})
    }

    const clearSearch = () => {
        GetTimeActivity()
        setDealSearch("");
        getAllDeals();
        setDealsAdvSearch({})
        setcurrentPage(1);
        setSearchedFlag(false)
        localStorage.removeItem("deals")
    }
    const clearLeadsData = () => {
        GetTimeActivity();

        setLeadsFormData({
            ...leadsFormData,
            enquirydate: "",
            phone: "",
            idc: "",
            leadname: "",
            leadclassification: "",
            companyname: "",
            contactdate: "",
            emailid: "",
            accountmanager: userData?.type !== "ACCOUNTMANAGER" ? "" : leadsFormData.accountmanager  // Set accountmanager only if userData.type is not "ACCOUNTMANAGER"
        });

        // Conditionally set isChecked1 to false if the user type is not "ACCOUNTMANAGER"
        if (userData?.type === "ACCOUNTMANAGER") {
            setIsChecked1(true);
        } else {
            setIsChecked1(false)
        }

        // Clear lead errors
        setLeadError({});
    };

    const clearNotifyData = () => {
        setNotifyData({ ...notifyData, accountmanager: "", companyname: "", clienttype: "", entity: "", companytype: "", agreement: false, signednda: false, commissiontype: "", commissionpercentage: "" })
        setLeadError({})
    }
    const clearConversionData = () => {
        GetTimeActivity()
        setConversationFormData({ ...conversationData, subject: "", leadclassification: "", enquirydate: "", contactdate: "", modeofcommunication: "", additionalcontacts: [], conversationsummary: "" })
        setLeadError({})
    }
    const clearClientData = () => {
        GetTimeActivity()
        setAddClientData({ type: "", entity: "", companyname: "" })
        setLeadError({})
    }
    const handleKeypress = (e) => {
        GetTimeActivity()

        if ((e.key === "Enter")) {
            setTimeout(function () {
                handleSearch();
            }, 100);
        }
    };



    const validateData = async () => {
        GetTimeActivity()
        let formIsValid = true;
        let error = { ...leadError };
        let mandatoryFileds = [{ name: 'Contact Name', key: 'leadname' }];

        if (mandatoryFileds) {
            mandatoryFileds.forEach(function (item) {
                if (
                    (leadsFormData[item.key]?.trim() === "" ||
                        leadsFormData[item.key] == undefined ||
                        leadsFormData[item.key] == "undefined")

                ) {
                    error[item.key] = item.name + " is required";
                    formIsValid = false;
                }
            });
        }

        if (isChecked1 && !leadsFormData?.accountmanager && leadsFormData?.accountmanager === "") {
            error['accountmanager'] = `Select accountmanager`;
            formIsValid = false;
        }
        if (!leadsFormData?.phone && leadsFormData?.idc) {
            error['phone'] = `Enter phone number`;
            formIsValid = false;
        }

        if (leadsFormData?.phone && !leadsFormData?.idc) {
            error['idc'] = `Select country code`;
            formIsValid = false;
        }

        if (leadsFormData?.emailid === undefined || leadsFormData?.emailid === "" || leadsFormData?.emailid?.length <= 0) {
            error['emailid'] = `Select or Enter email id`;
            formIsValid = false;
        } else {
            const regEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!regEx.test(leadsFormData?.emailid)) {
                error['emailid'] = `Please Enter Valid Email`;
                formIsValid = false;
            } else {
                error['emailid'] = '';
            }
        }

        // if (!leadsFormData?.leadclassification || leadsFormData?.leadclassification === "") {
        //     error['leadclassification'] = `Select contact classification`;
        //     formIsValid = false;
        // }



        setLeadError(error);
        return formIsValid;
    };
    const handlePageChangeExport = (page) => {
        GetTimeActivity()
        setCurrentPageEport(page);
    }
    const handlePerRowsChangeExport = (newPerPage) => {
        GetTimeActivity()
        setRowsPerPageExport(newPerPage);
    }

    const validateConvData = () => {
        GetTimeActivity()
        let formIsValid = true;
        let error = { ...leadError };

        if (!conversationFormData?.subject || conversationFormData?.subject?.trim() === "") {
            error['subject'] = `Enter subject`;
            formIsValid = false;
        }
        if (!conversationFormData?.contactdate || conversationFormData?.cantactdate?.trim() === "" || conversationFormData?.contactdate === "Invalid Date") {
            error['contactdate'] = `Enter contact date`;
            formIsValid = false;
        }
        if (!conversationFormData?.modeofcommunication || conversationFormData?.modeofcommunication?.trim() === "") {
            error['modeofcommunication'] = `Select mode of communication`;
            formIsValid = false;
        }
        if (!conversationFormData?.conversationsummary || conversationFormData?.conversationsummary?.trim() === "") {
            error['conversationsummary'] = `Enter conversation summary`;
            formIsValid = false;
        }


        setLeadError(error);
        return formIsValid
    }
    useEffect(() => {
        if (activeExportBtn && exportData && exportData.length > 0) {


            const interval = setInterval(() => {
                fetchExportData();

            }, 10000);
            return () => clearInterval(interval);
        }
    }, [exportData, activeExportBtn]);
    const validateClientData = () => {
        GetTimeActivity()
        let formIsValid = true;
        let error = { ...leadError };

        if (!addClientData?.type || addClientData?.type === "") {
            error['type'] = `Select client type`;
            formIsValid = false;
        }


        if (!addClientData?.entity || addClientData?.entity === "") {
            error['entity'] = `Select entity`;
            formIsValid = false;
        }
        if (!addClientData?.companyname || String.prototype.trim.call(addClientData?.companyname) === "") {
            if (addClientData?.entity === "INDIVIDUAL") {
                error['companyname'] = `Enter company name`;
            } else {
                error['companyname'] = `Select company name`;
            }

            formIsValid = false;
        }



        setLeadError(error);
        return formIsValid
    }
    const validateConvCommentsData = () => {
        GetTimeActivity()
        let formIsValid = true;
        let error = { ...leadError };


        if (!addComments?.comment || addComments?.comment?.trim() === "") {
            error['comment'] = `Enter follow up comment`;
            formIsValid = false;
        }
        if (!addComments?.nextfollowpdate || addComments?.nextfollowpdate.trim() === "" || addComments?.nextfollowpdate === "Invalid Date") {
            error['nextfollowpdate'] = `Select next follow up date`;
            formIsValid = false;
        }

        if (!addComments?.modeofcommuniciation || addComments?.modeofcommuniciation === "") {
            error['modeofcommuniciation'] = `Select mode of communication`;
            formIsValid = false;
        }


        setLeadError(error);
        return formIsValid
    }
    const validateContactData = () => {
        let formIsValid = true;
        let error = { ...leadError };
        if (!leadData?.phone && leadData?.idc) {
            error['phonenumber'] = `Enter phone number`;
            formIsValid = false;
        }


        if (leadData?.phone && !leadData?.idc) {
            error['Idc'] = `Select country code`;
            formIsValid = false;
        }
        setLeadError(error);
        return formIsValid
    }
    const validateNotifyData = () => {
        GetTimeActivity()
        let formIsValid = true;
        let error = { ...leadError };

        if (!notifyData?.companyname || String.prototype.trim.call(notifyData?.companyname) === "") {
            error['companyname'] = `Enter company name`;
            formIsValid = false;
        }


        if (!notifyData?.clienttype || notifyData?.clienttype === "") {
            error['clienttype'] = `Select content type`;
            formIsValid = false;
        }
        if (!notifyData?.companytype || notifyData?.companytype === "") {
            error['companytype'] = `Select company type`;
            formIsValid = false;
        }
        if (!notifyData?.entity || notifyData?.entity === "") {
            error['entity'] = `Select entity`;
            formIsValid = false;
        }
        if (!notifyData?.accountmanager || notifyData?.accountmanager === "") {
            error['accountmanager'] = `Enter accountmanager name`;
            formIsValid = false;
        }


        setLeadError(error);
        return formIsValid
    }
    const handleValidate = (e) => {
        GetTimeActivity()

        const isValid = validateData();
        isValid.then(result => {
            if (result === true) {
                handleAddFormData()
            }
        }).catch(error => {

        });
    }
    const handletoggle = async () => {
        console.log('handle toggle')
        setActiveExportBtn(true)

        // setExportFlag((prevState) => !prevState);

        if (activeExportBtn === true) {
            fetchExportData();

        }
        if (activeExportBtn === false) {

            setExportData([])
        }

    };

    const exportXlsLeadDataApi = (e) => {
        setExportLoad(true)

        const token = localStorage.getItem("token");
        let userid = localStorage.getItem("userId");
        axios({
            method: 'POST',
            url: lambda + '/leadExport?appname=' + appname + "&source=content&type=xls" + "&token=" + token + "&userid=" + userid + "&sortOrder=" + sortOrder + "&sortBy=leadname",
            data: (convSearchVal && contactSearchVal)  ? { "search": convSearchVal , "leadsearch":contactSearchVal  } :(convSearchVal || contactSearchVal)?  {"search": convSearchVal || contactSearchVal } : advSearch? processObject(advSearch): {}
        })
            .then(function (response) {
                if (response?.data?.result == "No data found with the filterd values") {
                    // setIsAlert(true)
                }
                else {
                    // setBtnDisable(true)
                    fetchExportData();
                }
            });
    };
    const fetchExportData = (e) => {
        setExportLoad(true)

        const token = localStorage.getItem("token");
        let userid = localStorage.getItem("userId");
        axios({
            method: 'POST',
            url: lambda + '/fetchLeadExports?appname=' + appname + "&source=content" + "&token=" + token + "&userid=" + userid,
          
            
        })
            .then(function (response) {
                if (response) {
                    if (response?.data?.result == "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {
                        setExportData(response?.data?.result);
                        //  console.log("export data", response?.data?.result);


                    }
                    setExportLoad(false)
                }
                setExportLoad(false)

            });
    };
    const handleClickSendEmail = async () => {

        const isValid = validateNotifyData();

        if (isValid) {

            GetTimeActivity()
            setBtnLoader("send")

            try {
                let payload = {
                    "companyname": notifyData?.companyname,
                    "accountmanager": notifyData?.accountmanager,
                    "clienttype": notifyData?.clienttype,
                    "companytype": notifyData?.companytype,
                    "entity": notifyData?.entity,
                    "agreement": notifyData?.agreement,
                    "signednda": notifyData?.signednda,
                    "commissiontype": notifyData?.commissiontype,
                    "commissionpercentage": notifyData?.commissionpercentage && notifyData.commissionpercentage.length > 0
                        ? `${notifyData.commissionpercentage}%`
                        : notifyData?.commissionpercentage,
                    leadid: saveLeadId
                };

                const response = await tmdbApi.NotifyAdmin(payload);


                if (response?.statusCode == 200) {
                    if (response?.result == "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else if (response?.result == "lead already exists") {
                        setShowExists(true)
                    } else {

                        getAllLeadsData();
                        // setSuccess(true);
                        // setAllDealsData({})
                        // setContentData({})

                        setLeadsFormData({})


                        setAdminPopup(false)

                        setBtnLoader("")
                        notify()
                        // setSaveLoaderEnable(false);
                    }
                }

            } catch {

            } finally {
                setBtnLoader("")
            }

        }
    }
    const handleDownload = async (url, props) => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const fileName = props.downloadLink.split('/').pop();

            const link = document.createElement("a");
            link.href = blobUrl;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };
    const handleAddFormData = async () => {
        // Filter the account list to find the user corresponding to the selected account manager
        const filterData = account?.filter((item) => item?.username === leadsFormData?.accountmanager) || [];

        // Determine the userId based on whether the checkbox is checked
        const userId = isChecked1 ? filterData?.[0]?.userid : localStorage.getItem("userId");

        GetTimeActivity()
        const updatedLeadsFormData = {
            ...leadsFormData,  // Spread existing form data
            createdBy: {
                userid: localStorage.getItem("userId"),  // Set userid (replace with dynamic value if necessary)
                name: userData?.name  // Set name (replace with dynamic value if necessary)

            },
            accountmanager: isChecked1 ? leadsFormData?.accountmanager : "",
            userid: userId
        };
        setBtnLoader("adding")
        try {

            const response = await tmdbApi.AddLead(updatedLeadsFormData);


            if (response?.statusCode == 200) {
                if (response?.result == "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else if (response?.result == "lead already exists") {
                    setShowExists(true)
                } else {

                    getAllLeadsData(response?.result);
                    // setSuccess(true);
                    // setAllDealsData({})
                    // setContentData({})

                    setLeadsFormData({})


                    setAddPopup(false)

                    setBtnLoader("")
                    // setSaveLoaderEnable(false);
                }
            }

        } catch {

        } finally {
            setBtnLoader("")
        }

    };

    const handleConversationData = async (data) => {


        GetTimeActivity()
        setBtnLoader("add")

        const isValid = validateConvData();
        if (isValid) {

            setLoaderEnable(true);
            try {
                let payload = {
                    "additionalcontacts": conversationFormData?.additionalcontacts ?? [],

                    "contactdate": conversationFormData?.contactdate,
                    "conversationsummary": conversationFormData?.conversationsummary,

                    "enquirydate": conversationFormData?.enquirydate,
                    "leadclassification": conversationFormData?.leadclassification,



                    "modeofcommunication": conversationFormData?.modeofcommunication,

                    "subject": conversationFormData?.subject, leadid: data,
                    "status": "open"

                }
                const response = await tmdbApi.AddConversation(payload);

                if (response?.statusCode == 200) {
                    if (response?.result == "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else if (response?.result == "lead already exists") {
                        setShowExists(true)
                    } else {


                        // setSuccess(true);
                        // setAllDealsData({})
                        // setContentData({})

                        setConversationFormData({})
                        getConversations(data)
                        setLoaderEnable(false);
                        setConversationpopup(false)
                        // getAllLeadsData()
                        setAddPopup(false)

                        setBtnLoader("")
                        // setSaveLoaderEnable(false);
                    }
                }

            } catch {

            } finally {
                setBtnLoader("")
            }
        }
    };
    const handleUpdateConversationData = async (data) => {
        GetTimeActivity()
        setBtnLoader("add")

        const isValid = validateConvData();
        if (isValid) {

            setLoaderEnable(true);
            try {
                let payload = {
                    "additionalcontacts": conversationFormData?.additionalcontacts ?? [],

                    "contactdate": conversationFormData?.contactdate,
                    "conversationsummary": conversationFormData?.conversationsummary,

                    "enquirydate": conversationFormData?.enquirydate,
                    "leadclassification": conversationFormData?.leadclassification,



                    "modeofcommunication": conversationFormData?.modeofcommunication,

                    "subject": conversationFormData?.subject, leadid: data,
                    "status": conversationFormData?.status

                }
                const response = await tmdbApi.UpdateConversation({ ...payload, conversationid: conversationFormData?.conversationid });

                if (response?.statusCode == 200) {
                    if (response?.result == "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else if (response?.result == "lead already exists") {
                        setShowExists(true)
                    } else {


                        // setSuccess(true);
                        // setAllDealsData({})
                        // setContentData({})

                        setConversationFormData({})
                        getConversations(data)
                        setLoaderEnable(false);
                        setConversationpopup(false)
                        // getAllLeadsData()
                        setAddPopup(false)

                        setBtnLoader("")
                        // setSaveLoaderEnable(false);
                    }
                }

            } catch {

            } finally {
                setBtnLoader("")
            }
        }
    }
    const handleClientAdd = async (value) => {

        const isValid = validateClientData();
        if (isValid) {
            setLoaderEnable(true)

            try {
                const payload = {
                    "personalemail": leadData?.emailid,
                    "name": leadData?.leadname,
                    "idc": leadData?.idc ?? "",
                    "phone": leadData?.phone ?? "",
                    "type": addClientData?.type,
                    "leadid": saveLeadId,
                    "companyname": addClientData?.companyname,
                    "entity": addClientData?.entity,
                    "source": "leadmanagement",
                    "createdBy": { userid: userData.userid, username: userData.name }

                }
                const response = await tmdbApi.SaveClientData(payload);

                if (response?.statusCode == 200) {
                    if (response?.result == "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else if (response?.result == "lead already exists") {
                        setShowExists(true)
                    } else {


                        getAllLeadsData(value)

                        // getBuyerList(value);
                        setClientPopup(false)

                        // setSaveLoaderEnable(false);
                    }
                }

            } catch {

            } finally {
                setBtnLoader("")
            }
        }


    }




    const client = (data) => {

        GetTimeActivity()
        let page = 1;
        //  setCurrentPage(1);
        // setIsLoading(true);
        const token = localStorage.getItem("token")
        const userid = localStorage.getItem("userId")

        axios({
            method: 'POST',
            url: lambda + '/clients?appname=' + appname + "&token=" + token + "&userid=" + userid,
        })
            .then(function (response) {

                if (response?.data?.result == "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    // setData(response?.data?.result?.data);
                    // global.exportExcelData = response?.data?.result?.data


                    setContent(response?.data?.result?.data);
                    const filterData = response?.data?.result?.data?.filter((item) => item.name === data?.leadname)

                    setClientData(filterData)

                    // setIsLoading(false);
                    // setClientMangeSearch("");
                    setSearchedFlag(false);
                }

            }).catch((err) => {
                console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
            });
    }

    const getDisplayText = (value) => {
        if (value) {
            const timestamp = new Date(value);
            const currentDate = new Date();

            // Compare dates without considering time
            const timestampDate = new Date(timestamp.getFullYear(), timestamp.getMonth(), timestamp.getDate());
            const currentDateDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());

            const diffTime = Math.abs(currentDateDate - timestampDate);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            if (diffDays === 0) {
                return 'Today';
            } else if (diffDays === 1) {
                return 'Yesterday';
            } else {
                return new Date(value).toLocaleDateString('en-IN', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                });
            }
        } else {
            return '';
        }
    };
    const getConversations = async (id) => {
        // setIsLoading(true)
        GetTimeActivity()

        // setSaveLoaderEnable(true);
        // setButtonDisabled(true);
        try {
            let payload = {
                leadid: id
            }
            if (convSearchRef.current?.trim()?.length > 0) payload.search = convSearchRef.current
            if (contactSearchRef.current?.trim()?.length > 0) payload.leadSearch = contactSearchRef.current
            const response = await tmdbApi.GetConversations(payload);

            if (response?.statusCode == 200) {
                if (response?.result == "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    // setSuccess(true);
                    // setAllDealsData({})
                    // setContentData({})

                    setLeadsFormData({})
                    setConversationData(response?.result)
                    if (conversationFormData?.conversationid) {
                        setActiveconversationItem(conversationFormData)
                    } else {
                        setActiveconversationItem(response?.result?.[0])
                    }


                    const data = response?.result?.[0].status
                    if (data === "open") {
                        setIsChecked(false)
                    } else {
                        setIsChecked(true)
                    }

                }
            }

        } catch {

        }
    }


    const getAllLeadsData = async (data) => {
        GetTimeActivity()
        setIsLoading(true)
        setLoaderEnable(true)


        try {
            const response = await tmdbApi.GetLeads();

            if (response?.statusCode === 200) {
                if (response?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {



                    if (data === "update") {

                        const leadData = response?.result?.data?.filter((item) => item?.leadid === saveLeadId)

                        if (leadSearch?.length > 0) {

                            const value = filterLeads?.filter((item) => item.leadid === saveLeadId)
                            setSaveLeadId(value?.[0]?.leadid)
                            setTempLeadList(filterLeads)
                            getConversations(value?.[0]?.leadid)
                            setAllLeadsData(response?.result?.data)
                            setLeadData(leadData?.[0])
                            setAssignAcm({ label: leadData?.[0]?.accountmanager, value: leadData?.[0]?.userid })
                            setAddClientData({ type: "", entity: "", companyname: "" })
                            setUpdateLead(true)
                            setLoaderEnable(false)
                            setBtnLoader("")
                            setIsLoading(false)
                        } else {


                            setSaveLeadId(leadData?.[0]?.leadid)
                            setPhoneNumber(leadData?.[0]?.phone)

                            setIdc(leadData?.[0]?.idc)
                            getConversations(leadData?.[0]?.leadid)
                            setAllLeadsData(response?.result?.data);
                            let data = response?.result?.data;

                            let index = data.indexOf(leadData?.[0]);
                            if (index !== -1) {
                                data.splice(index, 1);
                                data.unshift(leadData?.[0]);
                            }

                            setTempLeadList(data);

                            setUpdateLead(true)

                            setBtnLoader("")


                            setLoaderEnable(false)
                            setLeadData(leadData?.[0])
                            setAssignAcm({ label: leadData?.[0]?.accountmanager, value: leadData?.[0]?.userid })

                            setAddClientData({ type: "", entity: "", companyname: "" })

                            setIsLoading(false)
                        }

                    } else {

                        setLeadsFormData({})



                        // setLeadSerach("")
                        setIsLoading(false)
                        if (flagg && leadSearch?.length <= 0) {
                            const data = response?.result?.data?.filter((item) => item.clientid === flagg)
                            const item = response?.result?.data;

                            let index = item.indexOf(data?.[0]);
                            if (index !== -1) {
                                item.splice(index, 1);
                                item.unshift(data?.[0]);
                            }
                            setTempLeadList(item)
                            setSaveLeadId(data?.[0]?.leadid)
                            setAllLeadsData(response?.result?.data)
                            setLeadData(response?.result?.data?.[0])

                            setAssignAcm({ label: response?.result?.data?.[0]?.accountmanager, value: response?.result?.data?.[0]?.userid })
                            client(response?.result?.data?.[0])

                        } else if (leadSearch?.length > 0) {
                            const value = filterLeads?.filter((item) => item.leadid === saveLeadId)
                            setSaveLeadId(value?.[0]?.leadid)
                            setTempLeadList(filterLeads)
                            getConversations(value?.[0]?.leadid)
                            setAllLeadsData(response?.result?.data)
                            client(value?.[0])

                        } else {
                            setTempLeadList(response?.result?.data)
                            setSaveLeadId(response?.result?.data?.[0]?.leadid)
                            setAllLeadsData(response?.result?.data)
                            setLeadData(response?.result?.data?.[0])
                            setAssignAcm({ label: response?.result?.data?.[0]?.accountmanager, value: response?.result?.data?.[0]?.userid })
                            getConversations(response?.result?.data?.[0]?.leadid);
                            client(response?.result?.data?.[0])
                        }

                        // setLeadSerach(...leadSearch)

                        // setIdc(response?.result?.data?.[0]?.idc)
                        // setPhoneNumber(response?.result?.data?.[0]?.phone)


                        const Id = response?.result?.data?.[0]?.clientid






                        setLoaderEnable(false)
                        if (flagg?.length > 0) {
                            getAllDeals(flagg)
                            // setClientData(client)
                        } else if (Id) {
                            getAllDeals(Id)
                        }
                        else {
                            getAllDeals()
                        }


                    }











                }
            }

        } catch {

            setIsLoading(false)
        }
    };

    const handleExport = () => {
        // Add your export route/logic here
        // Option 1: Navigate to export page
        // navigate('/export');

        // Option 2: Call export API
        // window.location.href = '/api/export';

        // Option 3: Trigger download directly
        console.log('Export clicked');
        exportXlsLeadDataApi();
    };

    const handleAddConversation = (item, index) => {


        setSaveLeadId(item?.leadid)


        setAddComments({ nextfollowpdate: "", comment: "", modeofcommuniciation: "" })
        if (filterLeads.length <= 0) {

            const allLeadsData11 = tempLeadList
            const clickedList = allLeadsData11.splice(index, 1)[0];
            setAllLeadsData([clickedList, ...allLeadsData11]);
            setTempLeadList([clickedList, ...allLeadsData11]);

        }

        const filterArr = allLeadsData.filter(eachItem => eachItem?.leadid === item?.leadid)
        setFlagg(item.clientid)
        setLeadData(item)
        setAssignAcm({ label: item?.accountmanager, value: item?.userid })
        getAllDeals(item.clientid)


        setLeadError({})
        getConversations(item?.leadid)
        client(item)
    }

    const handleConversationClick = (item, index) => {
        if (tempLeadList?.length > 0) {
            setActiveconversationItem(item)
            if (item && item?.status === "open") {
                setIsChecked(false);
            } else {
                setIsChecked(true);
            }

            setAddComments({ nextfollowpdate: "", comment: "", modeofcommuniciation: "" })

            setLeadError({})
        }
    }
    const getAccount = async () => {
        GetTimeActivity()
        try {
            const response = await tmdbApi.getAccount({
            });
            if (response?.result == "Invalid token or Expired") {
                setShowSessionPopupup(true)
            } else {
                setAccount(response?.result);
            }

        } catch {
            console.log("error");
        }
    };

    const handleAddComments = async () => {

        GetTimeActivity()
        const isValid = validateConvCommentsData()
        if (isValid) {
            setBtnLoader("added")

            try {
                let payload = {
                    ...addComments, conversationid: activeconversationItem?.conversationid
                }
                const response = await tmdbApi.GetConversationComments(payload);

                if (response?.statusCode == 200) {
                    if (response?.result == "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {


                        conversationCommentsData(saveLeadId)


                    }
                }

            } catch {

            }
        }
    }


    const conversationCommentsData = async (data) => {
        GetTimeActivity()


        try {
            let payload = { leadid: data }
            const response = await tmdbApi.GetConversations(payload);

            if (response?.statusCode == 200) {
                if (response?.result == "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {

                    setConversationData(response?.result)


                    const ConvId = activeconversationItem?.conversationid
                    const activeData = response?.result?.filter((item) => item.conversationid === ConvId)

                    setActiveconversationItem(activeData[0])

                    setAddComments({ nextfollowpdate: "", comment: "", modeofcommuniciation: "" })
                    setBtnLoader("")

                }
            }

        } catch {

        }

    }
    const AddDeal = () => {
        setNavigateToggle("leads");
        navigate("/createdeal")
    }

    const updateLeadData = async (value) => {

        const isValid = validateContactData();
        if (isValid) {
            setLeadError({})
            setBtnLoader("update")
            try {
                let payload = { phone: leadData?.phone, leadid: saveLeadId, idc: leadData?.idc, clientid: leadData?.clientid }
                const response = await tmdbApi.UpdateLead(payload);

                if (response?.statusCode == 200) {
                    if (response?.result == "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {
                        getAllLeadsData(value)

                    }
                }

            } catch {

            }
        }

    }

    const updateAcm = async () => {
        setBtnLoader("updateAcm")
        const token = localStorage.getItem("token")
        const userid = localStorage.getItem("userId")

        const payload = {
            userid: assignAcm?.value,
            accountmanager: assignAcm?.label
        }
        axios({
            method: 'POST',
            url: lambda + '/updateLead?appname=' + appname + "&token=" + token + "&userid=" + userid + "&leadid=" + saveLeadId,
            data: payload
        })
            .then(function (response) {

                if (response?.data?.result == "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    getAllLeadsData('update')




                }

            }).catch((err) => {
                console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
            });
    }
    const updateConvData = async (data) => {


        try {
            const payload = {
                "status": data,
                "conversationid": activeconversationItem?.conversationid
            }
            const response = await tmdbApi.UpdateConvData(payload);

            if (response?.statusCode == 200) {
                if (response?.result == "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    conversationCommentsData(saveLeadId)

                }
            }

        } catch {

        }


    }

    const handleSelectCheckboxChange = (event) => {
        setIsChecked1(event.target.checked);
        if (event.target.checked === false) {
            setLeadError({ ...leadError, accountmanager: "" })
        }
        console.log("checked------------------------->", event.target.checked)
    }
    const handleLeadChange = (e) => {
        GetTimeActivity()


        const onlyDigits = e.target.value.replace(/\D/g, "")
        let errors = { ...leadError }
        errors[e.target.name] = "";
        setLeadError(errors)
        setLeadsFormData({ ...leadsFormData, [e.target.name]: e.target.value });
        if (e.target.name === "phone") {
            setLeadsFormData({ ...leadsFormData, phone: onlyDigits })
            setLeadError(prevErrors => ({
                ...prevErrors,
                idc: "",
            }));
        }
        else {
            if (e.target.name === "companyname") {
                setLeadsFormData({ ...leadsFormData, companyname: [e.target.value] })

            }
        }
        if (e.target.name === "idc") {
            setLeadError(prevErrors => ({
                ...prevErrors,
                phone: "",
            }));
        }

    }
    const handleAcmChange = (selected) => {

        setAssignAcm(selected); // Update state with the selected option

    }
    const handleConversionChange = (e) => {
        GetTimeActivity();
        let errors = { ...leadError };
        errors[e.target.name] = "";
        setLeadError(errors);
        setConversationFormData({ ...conversationFormData, [e.target.name]: e.target.value });

    };


    const handleClientChange = (e) => {
        let errors = { ...leadError }
        errors[e.target.name] = "";
        setLeadError(errors)

        if (e.target.value === "INDIVIDUAL") {
            setAddClientData({
                ...addClientData,
                companyname: leadData?.companyname,
                [e.target.name]: e.target.value

            });

            delete errors.companyname;
            setLeadError(errors);

        } else if (e.target.value === "COMPANY") {
            setAddClientData({
                ...addClientData,
                companyname: "",
                [e.target.name]: e.target.value
            });
            delete errors.companyname;
            setLeadError(errors);
        }
        else {
            setAddClientData({
                ...addClientData,
                [e.target.name]: e.target.value
            });
        }






    }
    const handleSearchLead = (e) => {
        setLeadSearch(e.target.value)

        const dummy = allLeadsData
        const k = dummy?.filter(obj => obj.leadname.toLowerCase().includes(e.target.value.toLowerCase()));
        // setSaveLeadId(k?.[0]?.leadid)

        setTempLeadList(k)
        setFilterLeads(k)


    }
    const handleChangeNotifyData = (e) => {
        const { name, value, checked } = e.target;
        const regex = /^\d*\.?\d{0,2}$/;
        let errors = { ...leadError };

        // Clear the error for the current input field
        errors[name] = "";
        setLeadError(errors);

        // Handle checkboxes
        if (name === 'agreement' || name === 'signednda') {
            setNotifyData({
                ...notifyData,
                [name]: checked
            });
        }
        // Handle commission percentage
        else if (name === "commissionpercentage") {
            if (value === '' || (regex.test(value) && value <= 100)) {
                setNotifyData({
                    ...notifyData,
                    [name]: value
                });
            }
        }
        // Handle other inputs
        else {
            setNotifyData({
                ...notifyData,
                [name]: value
            });
        }
    };




    const clearIconSearch = () => {
        SortData(sortOrder)
        setFlagg("")
        setActiveSearch(false);
        setClearIcon(false)
        setLeadSearch("")
        setSaveLeadId(allLeadsData?.[0]?.leadid)
        // setTempLeadList(allLeadsData)
        setLeadData(allLeadsData?.[0])
        setAssignAcm({ label: allLeadsData?.[0]?.accountmanager, value: allLeadsData?.[0]?.userid })
        getConversations(allLeadsData?.[0]?.leadid)
        getAllDeals(allLeadsData?.[0]?.clientid)
        setFilterLeads([])
    }
    const clearAdvSearch = () => {
        setFlag(false)
        getAllLeadsData()
        setAdvSearch({ contactName: "", company: "", accountManager: "", created: "", phone: "", email: "", status: "" });
    }
    const handleCommentsChange = (e) => {
        let errors = { ...leadError };
        errors[e.target.name] = "";
        setLeadError(errors);



        setAddComments({ ...addComments, [e.target.name]: e.target.value });

    };
    const handlePhoneIdc = (e) => {
        const { name, value } = e.target;
        setLeadError({})
        if (name === "Idc") {
            setLeadData({ ...leadData, idc: value });
        } else {
            const onlyDigits = value.replace(/\D/g, "");
            setLeadData({ ...leadData, phone: onlyDigits })
        }
    }

    const checkInput = (e) => {
        const onlyDigits = e.target.value.replace(/\D/g, "");
        setLeadError({})
        setPhoneNumber(onlyDigits);
    };
    const checkIdc = (e) => {

        setLeadError({})

        setIdc(e.target.value)
    }

    const handleBack = () => {
        setTempLeadList(allLeadsData)
        setFlag(false)
        setActiveSearch(false)
        setLeadSearch("")
        setFlagg("")
    }
    const handleAddClient = async () => {
        setClientPopup(true)
        setAddClientData({ type: "", entity: "", companyname: "" })

    }
    const handleSendEmail = () => {
        setAdminPopup(true)
        setNotifyData({ ...notifyData, accountmanager: userData?.name, companyname: leadData?.companyname, clienttype: "", entity: "", companytype: "", agreement: false, signednda: false, commissiontype: "", commissionpercentage: "" })
        setLeadError({})
    }
    const showContent = () => {
        setIsChecked(!isChecked)
        if (isChecked) {
            updateConvData("open")


        } else {
            updateConvData("close")
            setLeadError({})
        }
    }
    const handleAddData = () => {
        setConversationpopup(true)
        setConversationFormData({ subject: "", leadclassification: "", enquirydate: "", contactdate: "", modeofcommunication: "", additionalcontacts: [], conversationsummary: "" })
        setLeadError({})
    }



    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No deals were found for the searched keyword</p>
                </div> </div>
        )
    }



    const customNoRecordsMessage = () => {
        return (

            <div className="empty-state-body export-empty">
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">
                        No Export Data was found
                    </p>
                </div>
            </div>
        )
    }
    const SortData = (value) => {
        const token = localStorage.getItem("token")
        const userid = localStorage.getItem("userId")
        const baseUrl = lambda + '/leads?appname=' + appname + "&sortOrder=" + value + "&sortBy=leadname" + "&token=" + token + "&userid=" + userid

        const hasAdvSearch = dealsadvSearch && Object.keys(dealsadvSearch).length > 0 && Object.values(dealsadvSearch).some(v => v !== null && v !== '');
        const currentSearch = (contactSearchRef.current ?? contactSearchVal ?? '').trim();
        const hasContactSearch = currentSearch.length > 0;
        const currentConvSearch = (convSearchRef.current ?? convSearchVal ?? '').trim();
        const hasGlobalConvSearch = currentConvSearch.length > 0 && !hasContactSearch;

        if (hasGlobalConvSearch) {
            // Conv search results are already in state from /conversations endpoint.
            // /leads endpoint doesn't filter by conversation text, so sort client-side.
            const sorted = [...allLeadsData].sort((a, b) => {
                const aName = (a.leadname || a.name || '').toLowerCase();
                const bName = (b.leadname || b.name || '').toLowerCase();
                if (value === 'ascending') return aName.localeCompare(bName);
                return bName.localeCompare(aName);
            });
            setTempLeadList(sorted);
            setAllLeadsData(sorted);
            return;
        }

        let method = 'GET';
        let url = baseUrl;
        let data = {};

        if (hasAdvSearch) {
            method = 'POST';
            data = dealsadvSearch;
        } else if (hasContactSearch) {
            url = baseUrl + "&search=" + encodeURIComponent(currentSearch);
        }

        axios({ method, url, data })
            .then(function (response) {
                if (response?.data?.result == "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    const resultData = response?.data?.result?.data ?? [];
                    setTempLeadList(resultData);
                    setAllLeadsData(resultData);
                }
            }).catch((err) => {
                console.log('error', err);
            });
    }
    const handleSort = () => {
        const newOrder = sortOrder === "ascending" ? "descending" : "ascending";
        setSortOrder(newOrder);
        SortData(newOrder)

    };
    const handleAdvSearch = () => {
        setAdvSearchPopup(true)
    }
    useEffect(() => {
        if (activeExportBtn) {
            fetchExportData();
        }
    }, [activeExportBtn])
    const handleEdit = (id) => {
        const filterData = conversationData?.filter((item) => item.conversationid === id)
        setConversationFormData(filterData?.[0])
        setActiveconversationItem(filterData?.[0])
        setConversationpopup(true)
        console.log("edit----------------->", filterData)
    }

    const handleDeleteConversationPopup = (e, conversationid) => {
        e.stopPropagation();
        setDeleteConversationId(conversationid);
        setShowConvDeleteModal(true);
    }

    const handleDeleteConversation = async () => {
        try {
            const userid = localStorage.getItem("userId");
            const payload = {
                leadid: saveLeadId,
                conversationid: deleteConversationId,
                status: "ARCHIVED",
                archivedby: {
                    userid: userid,
                    archivedon: moment()
                }
            };
            await tmdbApi.UpdateConversation(payload);
            setShowConvDeleteModal(false);
            setDeleteConversationId("");
            const convResponse = await tmdbApi.GetConversations({ leadid: saveLeadId });
            if (convResponse?.statusCode == 200) {
                setConversationData(convResponse?.result);
                setActiveconversationItem(convResponse?.result?.[0]);
            }
        } catch {
            console.log("error archiving conversation");
        }
    }

    const activateFirstSearchResult = async (firstLead) => {
        if (!firstLead) return;
        setSaveLeadId(firstLead?.leadid)
        setAddComments({ nextfollowpdate: "", comment: "", modeofcommuniciation: "" })
        setFlagg(firstLead?.clientid)
        setLeadData(firstLead)
        setAssignAcm({ label: firstLead?.accountmanager, value: firstLead?.userid })
        getAllDeals(firstLead?.clientid)
        setLeadError({})
        await getConversations(firstLead?.leadid)
        client(firstLead)
    }

    const handleContactSearch = async () => {
        GetTimeActivity()
        setIsLoading(true)
        setContactSearchActive(true)
        setConvSearchEmptyActive(false)
        setDealsAdvSearch({})
        setAdvSearch({ contactName: "", company: "", accountManager: "", created: "", phone: "", email: "", status: "" })
        try {
            const response = await tmdbApi.GetLeads({ search: contactSearchVal });
            if (response?.statusCode === 200) {
                if (response?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    setAllLeadsData(response?.result?.data)
                    setTempLeadList(response?.result?.data)
                    await activateFirstSearchResult(response?.result?.data?.[0])
                }
            }
        } catch {
        } finally {
            setIsLoading(false)
        }
    }

    const handleConvSearchBtn = async () => {
        GetTimeActivity()
        setIsLoading(true)
        setDealsAdvSearch({})
        setAdvSearch({ contactName: "", company: "", accountManager: "", created: "", phone: "", email: "", status: "" })
        try {
            if (contactSearchVal?.trim()?.length > 0) {
                // Contact name + conversation text — filter within current lead
                const convResponse = await tmdbApi.GetConversations({ leadid: saveLeadId, search: convSearchVal, leadSearch: contactSearchVal });
                if (convResponse?.statusCode === 200) {
                    if (convResponse?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {
                        setConversationData(convResponse?.result)
                    }
                }
            } else if (convSearchVal?.trim()?.length > 0) {
                // Conversation-only global search — search across all leads
                const convResponse = await tmdbApi.GetConversations({ search: convSearchVal });
                if (convResponse?.statusCode === 200) {
                    if (convResponse?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {
                        const conversations = convResponse?.result ?? [];
                        if (conversations.length > 0) {
                            // Build unique leads list from conversation results
                            const leadMap = new Map();
                            conversations.forEach(conv => {
                                if (conv?.leadid && !leadMap.has(conv.leadid)) {
                                    leadMap.set(conv.leadid, {
                                        leadid: conv.leadid,
                                        leadname: conv.leadname ?? conv.name ?? "",
                                        companyname: conv.companyname ?? ""
                                    });
                                }
                            });
                            const uniqueLeads = Array.from(leadMap.values());
                            setAllLeadsData(uniqueLeads);
                            setTempLeadList(uniqueLeads);
                            setContactSearchActive(false);
                            setConvSearchEmptyActive(false);
                            await activateFirstSearchResult(uniqueLeads[0]);
                        } else {
                            setAllLeadsData([]);
                            setTempLeadList([]);
                            setContactSearchActive(false);
                            setConvSearchEmptyActive(true);
                            setConversationData([]);
                        }
                    }
                }
            } else {
                // No search value — fetch all conversations for current lead
                const convResponse = await tmdbApi.GetConversations({ leadid: saveLeadId });
                if (convResponse?.statusCode === 200) {
                    if (convResponse?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {
                        setConversationData(convResponse?.result)
                    }
                }
            }
        } catch {
        } finally {
            setIsLoading(false)
        }
    }

    const handleResetSearch = () => {
        contactSearchRef.current = "";
        convSearchRef.current = "";
        setContactSearchVal("");
        setConvSearchVal("");
        setContactSearchActive(false);
        setConvSearchEmptyActive(false);
        setSortOrder("ascending");
        getAllLeadsData();
        setAdvSearch({ contactName: "", company: "", accountManager: "", created: "", phone: "", email: "", status: "" });
    }


    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                <div className={isLoading || allLeadsData && allLeadsData?.length > 0 ? "main-content user-management deals clients lead_management" : "main-content deals clients user-management lm_emptypage"}>

                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row mb-4 breadcrumb">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-0 card-title">LEAD  Management</h4>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search Contacts By Name"
                                                    value={contactSearchVal}
                                                    onChange={(e) => { contactSearchRef.current = e.target.value; setContactSearchVal(e.target.value); }}
                                                    onKeyPress={(e) => e.key === 'Enter' && handleContactSearch()}
                                                    style={{ height: '40px', borderRadius: '5px 0 0 5px', border: '1px solid #afafaf', fontSize: '12px', width: '300px' }}
                                                />
                                                <button onClick={handleContactSearch} style={{ height: '40px', padding: '0 12px', background: 'transparent', border: '1px solid #afafaf', borderLeft: 'none', borderRadius: '0 5px 5px 0', display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                                    <span className="material-icons" style={{ fontSize: '19px', color: '#1C1B1F' }}>search</span>
                                                </button>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search conversations By Messages"
                                                    value={convSearchVal}
                                                    onChange={(e) => { convSearchRef.current = e.target.value; setConvSearchVal(e.target.value); }}
                                                    onKeyPress={(e) => e.key === 'Enter' && handleConvSearchBtn()}
                                                    style={{ height: '40px', borderRadius: '5px 0 0 5px', border: '1px solid #afafaf', fontSize: '12px', width: '300px' }}
                                                />
                                                <button onClick={handleConvSearchBtn} style={{ height: '40px', padding: '0 12px', background: 'transparent', border: '1px solid #afafaf', borderLeft: 'none', borderRadius: '0 5px 5px 0', display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                                    <span className="material-icons" style={{ fontSize: '19px', color: '#1C1B1F' }}>search</span>
                                                </button>
                                            </div>
                                            <button onClick={handleAdvSearch} style={{ height: '40px', padding: '0 13px', background: 'transparent', border: '1px solid #afafaf', borderRadius: '5px', fontSize: '11px', fontWeight: 500, color: '#474646', display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }}>

                                                Advanced Search
                                            </button>
                                            <button onClick={handletoggle} style={{ height: '40px', padding: '0 13px', background: 'transparent', border: '1px solid #afafaf', borderRadius: '5px', fontSize: '11px', fontWeight: 500, color: '#474646', display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }}>
                                                <span className="material-icons-outlined" style={{ fontSize: '16px', color: '#1C1B1F' }}>north_east</span>
                                                Export
                                            </button>
                                            <button onClick={handleResetSearch} style={{ height: '40px', padding: '0 13px', background: 'transparent', border: '1px solid #afafaf', borderRadius: '5px', fontSize: '11px', fontWeight: 500, color: '#474646', display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }}>
                                                <span className="material-icons-outlined" style={{ fontSize: '16px', color: '#1C1B1F' }}>sync</span>
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {activeExportBtn ? <div className="row table-data">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <>

                                                <div className="row p-3">
                                                    <div className='col-12 col-sm-12 button-block d-flex justify-content-between' >
                                                        {/* {exportData.length > 0 && ( */}
                                                        <div className="dataTables_length" id="datatable_length">
                                                            <button
                                                                className="fill_btn text-primary border-primary fw-bolder active"
                                                                onClick={(e) => handleExport(e, "xls")}
                                                            >
                                                                Export to XLS
                                                            </button>
                                                        </div>

                                                        <div className="dataTables_length" id="datatable_length">
                                                            <button
                                                                className="fill_btn"
                                                                onClick={() => setActiveExportBtn(false)}
                                                            >
                                                                <span className="material-icons">arrow_back</span>
                                                                BACK
                                                            </button>
                                                        </div>



                                                    </div>
                                                </div>
                                                {/* )} */}

                                                {exportData && exportData.length > 0 ? (
                                                    <DataTable
                                                        columns={columnsExport}
                                                        keyField="_id"
                                                        data={Array.isArray(exportData) ? exportData : []}
                                                        direction="auto"
                                                        highlightOnHover
                                                        fixedHeaderScrollHeight="300px"
                                                        pagination
                                                        responsive
                                                        persistTableHead
                                                        striped
                                                        subHeaderAlign="right"
                                                        defaultSortField="name"
                                                        noDataComponent={customNoRecordsMessage()}
                                                        paginationTotalRows={exportData.length}
                                                        onChangeRowsPerPage={handlePerRowsChangeExport}
                                                        onChangePage={handlePageChangeExport}
                                                        paginationPerPage={rowsPerPageExport}
                                                        paginationDefaultPage={currentPageExport}
                                                        paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                        paginationComponentOptions={{
                                                            rowsPerPageText: "Per page:",
                                                            rangeSeparatorText: "of",
                                                            noRowsPerPage: false,
                                                            selectAllRowsItem: false,
                                                            selectAllRowsItemText: "All",
                                                        }}
                                                        progressComponent={<TableLoader />}

                                                    />
                                                ) :

                                                    exportLoad ? (
                                                        <div className="empty-state-body export-empty">
                                                            <div className="empty-state__message">
                                                                <TableLoader />
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="empty-state-body export-empty">
                                                            <div className="empty-state__message">
                                                                <span className="material-icons">summarize</span>
                                                                <p className="form-check font-size-16">
                                                                    No Export Data was found
                                                                </p>
                                                            </div>
                                                        </div>
                                                    )

                                                }
                                            </>



                                        </div></div></div></div> :
                                <div className={allLeadsData && allLeadsData?.length > 0 && conversationData && conversationData?.length > 0 ? "row table-data" : "row table-data empty_conversation"}>
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body">


                                                {isLoading ? <TableLoader /> :
                                                    (allLeadsData && allLeadsData?.length <= 0 && contactSearchActive) ?
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '400px', gap: '14px' }}>
                                                            <div style={{ width: '90px', height: '90px', borderRadius: '50%', background: '#ECF0FA', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                <span className="material-icons" style={{ fontSize: '48px', color: '#F1A341' }}>person_search</span>
                                                            </div>
                                                            <p style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '15px', color: '#2c2c2c', margin: 0 }}>No Contacts found!</p>
                                                            <p style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 400, fontSize: '12px', color: '#9a9a9a', margin: 0 }}>Try a different name or click Reset to view all contacts</p>
                                                        </div>
                                                        : (allLeadsData && allLeadsData?.length <= 0 && convSearchEmptyActive) ?
                                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '400px', gap: '14px' }}>
                                                                <div style={{ width: '90px', height: '90px', borderRadius: '50%', background: '#ECF0FA', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <span className="material-icons" style={{ fontSize: '48px', color: '#F1A341' }}>forum</span>
                                                                </div>
                                                                <p style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '15px', color: '#2c2c2c', margin: 0 }}>No Conversations found!</p>
                                                                <p style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 400, fontSize: '12px', color: '#9a9a9a', margin: 0 }}>No contacts found with matching conversations. Try a different keyword or click Reset.</p>
                                                            </div>
                                                        : (conversationData && conversationData?.length <= 0 && allLeadsData && allLeadsData?.length <= 0) ?
                                                            <div className="welcome_lm">
                                                                <span><img src={image + "orasi/admin/resources/orasiv1/images/add-lead.png"} /></span>
                                                                <p>Welcome to Lead Management. <br></br>Add Contact to get started</p>
                                                                <a className="btn btn-primary" onClick={handleAddLead}>ADD lead</a>
                                                            </div>
                                                            : <>

                                                                <div className="lm_block">
                                                                    <div className="contacts">
                                                                        <div className={(activeSearch || flag) ? "header_block search_block" : "header_block"} >
                                                                            {/* ................................. */}
                                                                            {allLeadsData && allLeadsData?.length > 0 && <>


                                                                                <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                                                                                    <p style={{ margin: 0 }}>CONTACTS</p>
                                                                                    <Tooltip title="Add Contact" placement="top">
                                                                                        <button className="btn" onClick={handleAddLead} style={{ height: '28px', width: '28px', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '5px' }}>
                                                                                            <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>add</span>
                                                                                        </button>
                                                                                    </Tooltip>
                                                                                    <button
                                                                                        className="btn"
                                                                                        onClick={handleSort}
                                                                                        style={{
                                                                                            border: "1px solid  #afafaf",
                                                                                            color:  "#474646",
                                                                                            fontWeight: 600,
                                                                                            fontSize: '11px',
                                                                                            height: '28px',
                                                                                            padding: '0 8px',
                                                                                            borderRadius: '5px',
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                        }}
                                                                                    >
                                                                                        {sortOrder === "ascending" ? "A-Z" : "Z-A"}
                                                                                    </button>
                                                                                </div>

                                                                                <div className="d-flex align-items-center">



                                                                                    {/* 3 Dot Dropdown */}
                                                                                    {/* {(activeSearch || flag) ? null : ( */}
                                                                                    {/* <div className="dropdown ">
                                                                                        <button
                                                                                            className="btn dropdown-btn"
                                                                                            type="button"
                                                                                            data-bs-toggle="dropdown"
                                                                                            aria-expanded="false"
                                                                                        >
                                                                                            <span className="material-symbols-outlined menu-icon">more_horiz</span>
                                                                                        </button> */}

                                                                                    {/* <ul className="dropdown-menu dropdown-menu-end custom-dropdown"> */}

                                                                                    {/* Sort */}
                                                                                    {/* <li>
                                                                                                <button className="dropdown-item d-flex align-items-center gap-2" onClick={handleSort}>
                                                                                                    <img
                                                                                                        src={
                                                                                                            sortOrder === "ascending"
                                                                                                                ? "https://d2aif2zmoi437u.cloudfront.net/orasi/admin/resources/orasiv1/images/sort_by_alpha1.svg"
                                                                                                                : "https://d2aif2zmoi437u.cloudfront.net/orasi/admin/resources/orasiv1/images/sort_by_alpha.svg"
                                                                                                        }
                                                                                                        width="18"
                                                                                                        alt="sort"
                                                                                                    />
                                                                                                    Sort by Alpha
                                                                                                </button>
                                                                                            </li> */}

                                                                                    {/* Advanced Search */}
                                                                                    {/* <li>
                                                                                                <button
                                                                                                    className="dropdown-item d-flex align-items-center gap-2"
                                                                                                    onClick={handleAdvSearch}
                                                                                                >
                                                                                                    <img
                                                                                                        src="https://d2aif2zmoi437u.cloudfront.net/orasi/admin/resources/orasiv1/images/instant_mix.svg"
                                                                                                        width="18"
                                                                                                        alt="adv search"
                                                                                                    />
                                                                                                    Advanced Search
                                                                                                </button>
                                                                                            </li> */}

                                                                                    {/* Search */}
                                                                                    {/* <li>
                                                                                                <button
                                                                                                    className="dropdown-item d-flex align-items-center gap-2"
                                                                                                    onClick={(e) => handleActiveIcon(e)}
                                                                                                >
                                                                                                    <span className="material-symbols-outlined">search</span>
                                                                                                    Search
                                                                                                </button>
                                                                                            </li> */}

                                                                                    {/* Export */}
                                                                                    {/* <li>
                                                                                                <button
                                                                                                    className="dropdown-item d-flex align-items-center gap-2"
                                                                                                    onClick={handletoggle}
                                                                                                >
                                                                                                    <span className="material-symbols-outlined">north_east</span>
                                                                                                    Export
                                                                                                </button>
                                                                                            </li> */}

                                                                                    {/* </ul> */}
                                                                                    {/* </div> */}
                                                                                    {/* )} */}
                                                                                </div>

                                                                            </>}




                                                                        </div>
                                                                        <div className="lead_details">
                                                                            {tempLeadList.length > 0 ? tempLeadList && tempLeadList?.map((eachLead, index) => {


                                                                                return (
                                                                                    <div className={saveLeadId === eachLead?.leadid ? "details active" : "details disable"} key={index} onClick={() => handleAddConversation(eachLead, index)}>
                                                                                        <div className="flex-shrink-0 me-3">
                                                                                            <span className="user-badge">{eachLead?.leadname && eachLead?.leadname.split(" ").map(name => name[0]).join("")}</span>
                                                                                        </div>
                                                                                        <div className="flex-grow-1 align-self-center">
                                                                                            <div className="text-muted">
                                                                                                <h5 className="mb-1">{eachLead?.leadname}</h5>
                                                                                                <p className="mb-0">{eachLead?.companyname}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            }) :

                                                                                <div className="no_deals no_contact">
                                                                                    <span className="material-symbols-outlined">account_circle_off</span>
                                                                                    <p>No Contacts found!</p>
                                                                                    <a className="btn btn-primary" onClick={handleBack}>Go Back</a>
                                                                                </div>

                                                                            }
                                                                        </div>




                                                                    </div>
                                                                    {conversationData && conversationData?.length > 0 && <div className="conversation">
                                                                        <div className="header_block">
                                                                            <p>CONVERSATIONS</p>
                                                                            {conversationData && conversationData.length > 0 && isLoading <= 0 && <button className={tempLeadList?.length <= 0 || (userData?.userid !== leadData?.userid && userData?.type !== "ADMIN") ? "btn disable pe-none" : "btn"} onClick={(e) => handleAddData(e)}><span className="material-symbols-outlined">add</span>add</button>}
                                                                        </div>
                                                                        <div className="lead_details">
                                                                            {conversationData && conversationData.map((item, index) => {
                                                                                return (
                                                                                    <div className={
                                                                                        (item?.conversationid !== activeconversationItem?.conversationid)
                                                                                            ? "details disable"
                                                                                            : ((tempLeadList.length <= 0 || (userData.userid !== leadData.userid && userData?.type !== "ADMIN"))
                                                                                                ? "details pe-none disable"
                                                                                                : "details active")
                                                                                    }

                                                                                        key={conversationData._id} onClick={() => handleConversationClick(item, index)} >

                                                                                        <div className="flex-shrink-0 me-3">
                                                                                            <span className="user-badge">
                                                                                                <span className="material-symbols-outlined">
                                                                                                    {item?.modeofcommunication === "Video Call" ? 'videocam' : item?.modeofcommunication === "Phone" ? "call" : item?.modeofcommunication === "Messaging" ? 'sms' : item?.modeofcommunication === "Email" ? 'Email' : ""}
                                                                                                </span>
                                                                                            </span>
                                                                                        </div>

                                                                                        <div className="flex-grow-1 align-self-center">
                                                                                            <div className="text-muted">
                                                                                                <h6 className="mb-1 text-truncate">{item?.subject}</h6>
                                                                                                <p className="mb-0">{item?.leadclassification}</p>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="lead-item-edit" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                                            <button onClick={() => handleEdit(item?.conversationid)} disabled={item?.status === "close"} className="user-badge"><span className="material-symbols-outlined">edit</span></button>
                                                                                            {userData?.type === "ADMIN" &&
                                                                                                <button onClick={(e) => handleDeleteConversationPopup(e, item?.conversationid)} className="user-badge" style={{ color: '#e74c3c' }}><span className="material-symbols-outlined">delete_outline</span></button>
                                                                                            }
                                                                                        </div>
                                                                                        {item?.status === "close" ? <span className="badge badge_closed">closed</span> : <span className="badge">open</span>}

                                                                                    </div>
                                                                                )
                                                                            })}
                                                                        </div>

                                                                    </div>}
                                                                    {allLeadsData && allLeadsData?.length > 0 && (
                                                                        conversationData && conversationData?.length > 0 ?

                                                                            <div className="summary">
                                                                                <div className="header_block">

                                                                                    <p>Subject : {activeconversationItem?.subject}</p>
                                                                                    <div className="input-field switch-buttons d-flex align-items-center">
                                                                                        <label className="switch disable">
                                                                                            <input type="checkbox" checked={isChecked} disabled={tempLeadList <= 0 || (userData?.userid !== leadData?.userid && userData?.type !== "ADMIN")} onChange={showContent} name="signednda" />
                                                                                            <span className="slider round">
                                                                                            </span>
                                                                                        </label>
                                                                                        {activeconversationItem?.status === "close" ? <label className="col-form-label">CLOSED</label> : <label className="col-form-label">{activeconversationItem?.status?.toUpperCase()}</label>}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="summary_details">
                                                                                    <div className="d-flex align-items-center justify-content-between">
                                                                                        <p className="mb-0 conversation_summary">Conversation Summary</p>
                                                                                        <div>
                                                                                            {/* <p className="mb-0 enquiry_date">Contacted By: <span>{userData?.name}</span></p> */}
                                                                                            <p className="mb-0 enquiry_date">Contacted On: <span>{activeconversationItem && moment(activeconversationItem?.contactdate).locale('en-in').format('D MMM YYYY')}</span></p>
                                                                                        </div>



                                                                                    </div>
                                                                                    <p className="conversation_details">{activeconversationItem?.conversationsummary}</p>
                                                                                    {activeconversationItem?.additionalcontacts?.length > 0 && <p className="mb-0 conversation_summary additional_contacts">Additional Contacts:</p>}

                                                                                    <p class="conversation_details contact_details">

                                                                                        {activeconversationItem && activeconversationItem?.additionalcontacts?.map((contact, index) => (
                                                                                            <span key={index}>
                                                                                                {index > 0 && ', '}
                                                                                                {contact?.value}
                                                                                            </span>
                                                                                        ))}


                                                                                    </p>
                                                                                    {activeconversationItem && activeconversationItem?.comments?.map((item, index) => {
                                                                                        return (
                                                                                            <div className="communication_details" key={index}>
                                                                                                <p className="day_divider">

                                                                                                    <span className="or"> {getDisplayText(item?.created)} </span>

                                                                                                </p>
                                                                                                <div className="details">
                                                                                                    <div className="flex-shrink-0 me-3">
                                                                                                        <span className="user-badge">
                                                                                                            <span className="material-symbols-outlined"> {item?.modeofcommuniciation === "Video Call" ? 'videocam' : item?.modeofcommuniciation === "Phone" ? "call" : item?.modeofcommuniciation === "Messaging" ? 'sms' : item?.modeofcommuniciation === "Email" ? 'Email' : ""} </span>
                                                                                                            {/* {item?.modeofcommuniciation === "Video Cal" && <span className="material-symbols-outlined">videocam</span> || item?.modeofcommuniciation === "Phone" && <span className="material-symbols-outlined">call</span> || item?.modeofcommuniciation === "Messaging" && <span className="material-symbols-outlined">sms</span> || item?.modeofcommuniciation === "Phone" && <span className="material-symbols-outlined">call</span> || item?.modeofcommuniciation === "Email" && <span className="material-symbols-outlined">Email</span>} */}
                                                                                                        </span>

                                                                                                    </div>
                                                                                                    <div className="flex-grow-1 align-self-center">
                                                                                                        <div className="text-muted">
                                                                                                            <p className="description">{item?.comment}</p>
                                                                                                            <div className="d-flex gap-3 align-items-center">
                                                                                                                <p className="nextflw_up mb-0">
                                                                                                                    Next Follow up :
                                                                                                                    <span>
                                                                                                                        {item && moment(item?.nextfollowpdate)
                                                                                                                            .locale('en-in')
                                                                                                                            .format('D MMM YYYY')}
                                                                                                                    </span>
                                                                                                                </p>

                                                                                                                <p className="nextflw_up mb-0">
                                                                                                                    Created By :
                                                                                                                    <span>{item?.username}</span>
                                                                                                                </p>
                                                                                                            </div>

                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        )
                                                                                    })}






                                                                                </div>
                                                                                <>
                                                                                    <div className={(isChecked || tempLeadList.length <= 0 || (userData?.userid !== leadData?.userid && userData?.type !== "ADMIN")) ? "flwup_comments pe-none disable" : "flwup_comments"}>

                                                                                        <textarea id="email" placeholder="Follow Up Comments" name="comment" type="text" className="form-control" spellcheck="false" value={addComments?.comment} onChange={(e) => handleCommentsChange(e)}></textarea>
                                                                                        {leadError.comment !== "" && <span className="errormsg enter_comment" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.comment}</span>}
                                                                                        <div className="communication_mode">
                                                                                            <div className="input-field next_flwupdate "><label className="form-label form-label">next follow up Date</label><span className="required">*</span>
                                                                                                <input type="date" id="birthday" name="nextfollowpdate" className="form-control"
                                                                                                    min={moment().format('YYYY-MM-DD')}


                                                                                                    value={moment(addComments?.nextfollowpdate).format('YYYY-MM-DD')}

                                                                                                    onChange={(e) => handleCommentsChange(e)} />
                                                                                                {leadError.nextfollowpdate !== "" && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.nextfollowpdate}</span>}
                                                                                            </div>
                                                                                            <div className="input-field mode_communication"><label className="form-label form-label">Mode of communication</label><span className="required">*</span>
                                                                                                <select className="form-select" placeholder="Select Featured" name="modeofcommuniciation" value={addComments?.modeofcommuniciation} onChange={(e) => handleCommentsChange(e)}>
                                                                                                    <option value="">Select</option>
                                                                                                    <option value="Email">Email</option>
                                                                                                    <option value="Phone">Phone</option>
                                                                                                    <option value="Messaging">Messaging</option>
                                                                                                    <option value="Video Call">Video Call</option>
                                                                                                </select>


                                                                                                {leadError.modeofcommuniciation !== "" && <span className="errormsg " style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.modeofcommuniciation}</span>}
                                                                                            </div>
                                                                                            <div className="flp_btn">
                                                                                                <label className="form-label form-label">add</label>
                                                                                                <a className={isChecked || btnLoader === "added" || (userData?.userid !== leadData?.userid && userData?.type !== "ADMIN") ? "btn btn-primary pe-none" : "btn btn-primary"} onClick={() => handleAddComments()}>
                                                                                                    {btnLoader === "added" ? (
                                                                                                        <img src={image + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"} className="loading-icon" />
                                                                                                    ) : null}
                                                                                                    add
                                                                                                </a>

                                                                                            </div>

                                                                                        </div>
                                                                                    </div>

                                                                                </>



                                                                            </div> :

                                                                            <div className="summary">
                                                                                <div className="header_block">
                                                                                    <div className="d-flex align-items-center">
                                                                                        <p>CONVERSATIONS</p>
                                                                                    </div>
                                                                                </div>
                                                                                {convSearchVal && convSearchVal.trim()
                                                                                    ? <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: '350px', gap: '14px' }}>
                                                                                        <div className="d-flex align-items-center justify-content-center rounded-circle" style={{ width: '90px', height: '90px', background: '#ECF0FA' }}>
                                                                                            <span className="material-icons" style={{ fontSize: '48px', color: '#F1A341' }}>forum</span>
                                                                                        </div>
                                                                                        <p className="mb-0 fw-bold" style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '15px', color: '#2c2c2c' }}>No Conversations found!</p>
                                                                                        <p className="mb-0" style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '12px', color: '#9a9a9a' }}>Try a different keyword or click Reset to view all</p>
                                                                                    </div>
                                                                                    : <div className="summary_details">
                                                                                        <span><img src={image + "orasi/admin/resources/orasiv1/images/add-conversation.png"} /></span>
                                                                                        <p>It&apos;s the beginning of conversations of the contact. Click &apos;Add&apos; to start one.</p>
                                                                                        <a className={"btn btn-primary out-line " + (tempLeadList <= 0 || (userData?.userid !== leadData?.userid && userData?.type !== "ADMIN") ? "pe-none disable" : "")} onClick={(e) => handlAddConversation(e)}>ADD CONVERSATION</a>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                    )}

                                                                    <>

                                                                        {
                                                                            saveLeadId === leadData?.leadid && (
                                                                                <div className="profile_details">
                                                                                    <div className="details">
                                                                                        <div className='d-flex align-items-center'>
                                                                                            <div className="flex-shrink-0 me-3">
                                                                                                <span className="user-badge">
                                                                                                    {leadData?.leadname && leadData?.leadname.split(" ").map(name => name[0]).join("")}
                                                                                                </span>


                                                                                            </div>
                                                                                            <div className="d-flex flex-column">
                                                                                                <div className="flex-grow-1 align-items-start">
                                                                                                    <div className="text-muted">
                                                                                                        <h5 className="mb-1">{leadData?.leadname}</h5>
                                                                                                        <p className="mb-0">{leadData?.companyname}</p>
                                                                                                    </div>
                                                                                                </div>
                                                                                                {leadData?.type && leadData?.type?.length > 0 && (
                                                                                                    <span className="badge ">{leadData?.type}</span>
                                                                                                )
                                                                                                    // : (
                                                                                                    //     <button className={tempLeadList?.length <= 0 || (userData?.userid !== leadData?.userid && userData?.type !== "ADMIN") ? "btn pe-none disable" : "btn"} onClick={() => handleAddClient()}>
                                                                                                    //         <span className="material-symbols-outlined">add</span>CLIENT
                                                                                                    //     </button>
                                                                                                    // )
                                                                                                }

                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="justify-content-center d-flex">
                                                                                            {userData?.type === "ACCOUNTMANAGER" || userData?.type === "MANAGER" ? <button className={leadData?.notifyAdminSendEmail === true || userData?.userid !== leadData?.userid ? "btn email_admin disable pe-none" : "btn email_admin"} onClick={() => handleSendEmail()}>
                                                                                                <span className="material-symbols-outlined">send</span>Email to Admin</button> : null}
                                                                                        </div>



                                                                                    </div>
                                                                                    <div>

                                                                                    </div>
                                                                                    {userData?.type === "ADMIN" && <div className="profile_update">
                                                                                        <div className="input-field">
                                                                                            <label className="col-form-label">Assigned lead to :</label>
                                                                                            <Select
                                                                                                isMulti={false}
                                                                                                placeholder="Select"
                                                                                                onChange={(e) => handleAcmChange(e, 'acm')}
                                                                                                defaultValue={userData?.name}
                                                                                                options={
                                                                                                    account && account.length > 0
                                                                                                        ? account.map((eachItem) => ({
                                                                                                            value: eachItem.userid,
                                                                                                            label: eachItem.username,
                                                                                                        }))
                                                                                                        : []
                                                                                                }
                                                                                                value={
                                                                                                    assignAcm
                                                                                                        ? account
                                                                                                            ?.map((eachItem) => ({
                                                                                                                value: eachItem.userid,
                                                                                                                label: eachItem.username,
                                                                                                            }))
                                                                                                            .find((option) => option.label === assignAcm?.label) // Match the option by label
                                                                                                        : { value: '', label: "Admin" }
                                                                                                }
                                                                                            />
                                                                                        </div>
                                                                                        <a
                                                                                            className={"btn btn-primary out-line"}

                                                                                            onClick={() => updateAcm('updateAcm')}
                                                                                        >
                                                                                            {btnLoader === 'updateAcm' ? (
                                                                                                <img
                                                                                                    src={`${image}orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg`}
                                                                                                    className="loading-icon"
                                                                                                />
                                                                                            ) : null}
                                                                                            Update
                                                                                        </a>
                                                                                    </div>}

                                                                                    <div className="profile_update">
                                                                                        <div className="input-field">
                                                                                            <label className="col-form-label">Email</label>
                                                                                            <input className="form-control" placeholder="Enter Email" type="text" name="emailid" id="example-text-input" value={leadData?.emailid} disabled />
                                                                                        </div>
                                                                                        <div className="input-field">
                                                                                            <label className="col-form-label">Country Code</label>
                                                                                            <div className="country-code">

                                                                                                <select name="Idc" className="colorselect capitalize" disabled={tempLeadList <= 0 || (userData?.userid !== leadData?.userid && userData?.type !== "ADMIN")} value={leadData?.idc} onChange={(e) => handlePhoneIdc(e)}>
                                                                                                    <option value="">Select</option>
                                                                                                    {countries && countries?.length > 0 && countries?.map((task, i) => {
                                                                                                        return (
                                                                                                            <><option key={i} value={task?.alpha3}>{task?.name?.toUpperCase() + task?.countrycode}</option></>
                                                                                                        )
                                                                                                    }
                                                                                                    )}
                                                                                                </select>

                                                                                                <label className="col-form-label">Phone Number</label>
                                                                                                <input className="form-control contact-number" type="tel" name="phonenumber" placeholder="Enter phone number" value={leadData?.phone} disabled={tempLeadList <= 0 || (userData?.userid !== leadData?.userid && userData?.type !== "ADMIN")} onChange={(e) => handlePhoneIdc(e)}
                                                                                                    maxLength="10" id="example-tel-input" />

                                                                                            </div>
                                                                                            {leadError?.Idc && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.Idc}</span>}
                                                                                            {leadError?.phonenumber && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.phonenumber}</span>}

                                                                                        </div>

                                                                                        <a className={`btn btn-primary out-line ${tempLeadList <= 0 || (userData?.userid !== leadData?.userid && userData?.type !== "ADMIN") ? 'disable pe-none' : ''}`} disabled={tempLeadList <= 0} onClick={() => updateLeadData("update")}>{btnLoader === "update" ? (<img src={image + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"} className="loading-icon" />) : null}update</a>
                                                                                    </div>
                                                                                </div>
                                                                            )

                                                                        }

                                                                    </>



                                                                </div>

                                                            </>}


                                                {
                                                    !isLoading && allLeadsData?.length > 0 && conversationData?.length > 0 && (
                                                        <>
                                                            {data && data?.length > 0 && clientData?.[0]?.status !== "INACTIVE" && clientData?.[0]?.status !== "REJECT" ? (
                                                                <div className="addl_block">
                                                                    <p>deals</p>
                                                                    <button onClick={() => AddDeal()} className={tempLeadList?.length <= 0 || (userData?.userid !== leadData?.userid && userData?.type !== "ADMIN") ? "btn pe-none disable" : "btn"}>
                                                                        <span className="material-symbols-outlined">add</span>add
                                                                    </button>
                                                                </div>
                                                            ) : (leadData && leadData.type?.length > 0 && (leadData.type === "BUYER" || leadData.type === "BOTH") && (clientData && clientData?.[0]?.status !== "INACTIVE") && (clientData && clientData?.[0]?.status !== "REJECT")) ? (
                                                                <div className="no_deals">
                                                                    <span className="material-symbols-outlined">list_alt</span>
                                                                    <p>No Deals found for this client!</p>
                                                                    <a className={tempLeadList?.length <= 0 || (userData?.userid !== leadData?.userid && userData?.type !== "ADMIN") ? "btn btn-primary pe-none disable" : "btn btn-primary"} onClick={() => AddDeal()}>Add deal</a>
                                                                </div>
                                                            )
                                                                // : !leadData?.type ? (
                                                                //     <>
                                                                //         <div className="no_deals">
                                                                //             <span className="material-symbols-outlined">list_alt</span>
                                                                //             <p>Deals are not visible until the lead is converted into a client</p>
                                                                //             <button className={tempLeadList?.length <= 0 || (userData?.userid !== leadData?.userid && userData?.type !== "ADMIN") ? "btn add_client pe-none disable" : "btn add_client"} onClick={() => handleAddClient()}>
                                                                //                 <span className="material-symbols-outlined">add</span>CLIENT
                                                                //             </button>
                                                                //         </div>

                                                                //     </>
                                                                // ) 
                                                                : (null)}
                                                            {data && data?.length > 0 && (
                                                                < DataTable key={keyForRerender}

                                                                    // title=""
                                                                    columns={columns}
                                                                    // className="table align-middle table-nowrap table-check"
                                                                    keyField='_id'
                                                                    data={data}
                                                                    direction="auto"
                                                                    highlightOnHover
                                                                    fixedHeaderScrollHeight="300px"
                                                                    pagination
                                                                    responsive
                                                                    persistTableHead
                                                                    // selectableRowsVisibleOnly
                                                                    striped
                                                                    // selectableRowsHighlight
                                                                    // selectableRows
                                                                    subHeaderAlign="right"
                                                                    defaultSortField="name"
                                                                    subHeaderWra
                                                                    noDataComponent={customNoRecords()}
                                                                    paginationTotalRows={data && data.length}
                                                                    onChangeRowsPerPage={handlePerRowsChange}
                                                                    onChangePage={handlePageChange}
                                                                    paginationPerPage={rowsPerPage}
                                                                    paginationDefaultPage={currentPageNew}
                                                                    paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                                    sortFunction={customSort}

                                                                    paginationComponentOptions={{
                                                                        rowsPerPageText: 'Per page:',
                                                                        rangeSeparatorText: 'of',
                                                                        noRowsPerPage: false,
                                                                        selectAllRowsItem: false,
                                                                        selectAllRowsItemText: 'All',
                                                                    }}

                                                                    progressPending={isLoading}
                                                                    progressComponent={<TableLoader />}
                                                                />
                                                            )}
                                                        </>
                                                    )
                                                }



                                            </div>

                                        </div>
                                    </div>
                                </div>
                            }


                        </div>
                    </div>
                    <SweetAlert show={success2}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Deleted SuccessFully"}
                        onConfirm={e => { setSuccess2(false) }}
                    ></SweetAlert>
                    <SweetAlert show={success}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"No Results Found"}
                        onConfirm={e => onConfirm()}
                    >
                    </SweetAlert>
                    <SweetAlert show={success}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"No Results Found"}
                        onConfirm={e => onConfirm()}
                    >
                    </SweetAlert>
                    <SweetAlert show={updateLead}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Updated SuccessFully"}
                        onConfirm={e => onConfirmUpdate()}
                    >
                    </SweetAlert>
                    <SweetAlert show={showExists}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"This Lead had been assigned to another Account Manager."}
                        onConfirm={e => onConfirm1()}
                    >
                    </SweetAlert>
                    <SweetAlert show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Something went wrong. Please reload again."}
                        onConfirm={e => setTableErrMsg(false)}
                    >
                    </SweetAlert>
                    <Modal className="access-denied" show={isdelete}>

                        <div className="modal-body enquiry-form">
                            <div className="container">
                                <button className="close-btn" onClick={e => onCancel()}><span className="material-icons">close</span></button>
                                <span className="material-icons access-denied-icon">delete_outline</span>
                                <h3>Delete</h3>
                                <p>This action cannot be undone.</p>
                                <p>Are you sure you want to delete File?</p>
                                <div className="popup-footer">
                                    <button className="fill_btn yellow-gradient" data-bs-toggle="modal" data-bs-target="#recommendModal" onClick={e => handleDeleteExportFile()}> {loaderDelete ? (<img src="https://d9nwtjplhevo0.cloudfront.net/orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg" className="loading-icon" />) : null}Yes, Delete</button>
                                </div>
                            </div>
                        </div>

                    </Modal>

                    <Modal className="access-denied" show={showConvDeleteModal}>
                        <div className="modal-body enquiry-form">
                            <div className="container">
                                <button className="close-btn" onClick={() => { setShowConvDeleteModal(false); setDeleteConversationId(""); }}><span className="material-icons">close</span></button>
                                <span className="material-icons access-denied-icon">delete_outline</span>
                                <h3>Delete Conversation</h3>
                                <p>This action cannot be undone.</p>
                                <p>Are you sure you want to delete this conversation?</p>
                                <div className="popup-footer">
                                    <button className="fill_btn yellow-gradient" onClick={handleDeleteConversation}>Yes, Delete</button>
                                </div>
                            </div>
                        </div>
                    </Modal>

                    <Modal className="advance-search search-popup al_pop add-contact" show={addPopup} onHide={handleCloseAddPopup} backdrop="static">
                        <Modal.Header closeButton>
                            <Modal.Title>Add Contact</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">Contact Name</label>
                                            <span className="required">*</span>
                                            <input className="form-control" placeholder="Enter Contact Name" type="text" name="leadname"
                                                value={leadsFormData?.leadname} onChange={(e) => handleLeadChange(e)}
                                                id="example-text-input" />
                                            {leadError?.leadname !== "" && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.leadname}</span>}
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">Email ID</label>
                                            <span className="required">*</span>
                                            <CreatableSelect
                                                placeholder='Select'
                                                onChange={(e) => handleChangeEmail(e, 'emailid')}
                                                onFocus={handleRemoveError}

                                                options={buyerdata && buyerdata.map((eachItem) => { return { value: eachItem.personalemail, phone: eachItem.personalphone, label: eachItem.personalemail, idc: eachItem.idc, name: eachItem.name, companyname: eachItem.companyname, accountmanager: eachItem.companyData?.[0]?.accountmanager } })}
                                                value={leadsFormData && leadsFormData?.emailid && leadsFormData?.emailid?.length > 0 ? conversationFormData?.personalemail?.map((eachItem) => { return { value: eachItem, label: eachItem } }) : ""
                                                }
                                            />
                                            {leadError.emailid !== "" && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.emailid}</span>}
                                            {/* <input
             className="form-control"
             placeholder="Enter Email ID"
             type="text"
             name="emailid"
             value={leadsFormData?.emailid}
             onChange={(e) => handleLeadChange(e)}
             id="example-text-input"
         />
         // {leadError.emailid !== "" && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.emailid}</span>} */}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">Company name</label>
                                            <input className="form-control contact-number" name="companyname" type="email" placeholder="Enter Company Name"
                                                value={leadsFormData?.companyname} onChange={(e) => handleLeadChange(e)}
                                                id="example-email-input" />



                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                <label className="col-form-label">Account Manager</label>
                                                <div className="export_title_block" style={{ border: 'none', padding: '0' }}>
                                                    <div className="export_title" style={{ border: 'none', padding: '0px', margin: '0px 0px 5px 15px' }}
                                                    >
                                                        <div className="font-size-11">
                                                            <input className="form-check-input" type="checkbox" style={{ width: "14px", height: "14px" }} checked={isChecked1} disabled={userData?.type === "ACCOUNTMANAGER"} onChange={handleSelectCheckboxChange} />
                                                        </div>
                                                        <p style={{ marginLeft: "5px" }}>Assign</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <select className="form-select" name="accountmanager" value={userData?.type === "ACCOUNTMANAGER" ? userData?.name : leadsFormData?.accountmanager} disabled={userData?.type === "ACCOUNTMANAGER"} onChange={(e) => handleLeadChange(e)}>
                                                <option value="">Select</option>

                                                {account?.map((item) => {
                                                    return (
                                                        <option>{item?.username}</option>
                                                    )
                                                })}


                                            </select>
                                            {leadError?.accountmanager && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.accountmanager}</span>}

                                        </div>
                                    </div>


                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">COUNTRY CODE</label>
                                            <div className="country-code">
                                                <select name="idc" className="form-select colorselect capitalize"
                                                    value={leadsFormData?.idc} onChange={(e) => handleLeadChange(e)}
                                                >
                                                    <option value="">Select Country</option>
                                                    {countries && countries?.length > 0 && countries?.map((task, i) => {
                                                        return (
                                                            <><option key={i} value={task?.alpha3}>{task?.name?.toUpperCase() + task?.countrycode}</option></>
                                                        )
                                                    }
                                                    )}
                                                </select>
                                            </div>
                                            {leadError?.idc && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.idc}</span>}

                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">PHONE Number</label>
                                            <div className="country-code">

                                                <input className="form-control contact-number" type="tel" name="phone" placeholder="Enter Phone Number"
                                                    value={leadsFormData?.phone} onChange={(e) => handleLeadChange(e)}
                                                    maxLength="10" id="example-tel-input" />

                                            </div>
                                            {leadError?.phone && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.phone}</span>}

                                        </div>
                                    </div>


                                    {/* <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">Contact Classification</label> <span className="required">*</span>
                                            <select className="form-select" name="leadclassification" value={leadsFormData?.leadclassification} onChange={(e) => handleLeadChange(e)}>
                                                <option value="">Select</option>

                                                <option>Awareness</option>
                                                <option>Interest</option>
                                                <option>Desire</option>
                                                <option>Confirmation</option>
                                                <option>Conversion</option>
                                            </select>
                                            {leadError?.leadclassification && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.leadclassification}</span>}

                                        </div>
                                    </div> */}

                                </div>
                            </div>
                        </Modal.Body>
                        {/* <Modal.Body className="border-top">
                             <div>
                                 <div className="row">
                                    
 
 
                                 </div>
                             </div>
                         </Modal.Body> */}
                        <Modal.Footer>
                            <div className="adv_footer">

                                <button className="fill_btn yellow-gradient reset-btn" onClick={clearLeadsData}><span className="material-icons-outlined">sync</span>Reset</button>

                                <button onClick={(e) => handleValidate(e)} className={btnLoader === "adding" && "pe-none"}
                                // className={`fill_btn yellow-gradient float-end ${Object.keys(searchPayload).length == 0 ? "disable" : ""}`} disabled={Object.keys(searchPayload).length == 0} 
                                >
                                    {btnLoader === "adding" ? (<img src={image + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"} className="loading-icon" />) : null}   ADD
                                </button>

                                <div className="clearfix"></div>
                            </div>
                        </Modal.Footer>
                    </Modal>
                    <Modal className="advance-search search-popup" show={advSearchPopup} onHide={handleClosePopup} backdrop="static">
                        <Modal.Header closeButton>
                            <Modal.Title>Advanced Search</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">CONTACT NAME</label>
                                            <input className="form-control" placeholder="Enter Name" type="text" name="contactName"
                                                value={advSearch?.contactName} onChange={(e) => handleChange(e)}
                                                id="example-text-input" />

                                        </div>
                                    </div>



                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">EMAIL ID</label>

                                            <input className="form-control" placeholder="Enter Email" type="text" name="email"
                                                value={advSearch?.email} onChange={(e) => handleChange(e)}
                                                id="example-text-input" />

                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">PHONE</label>
                                            {/* <div className="country-code"> */}
                                            {/* <select name="idc" className="colorselect capitalize"
                                                    value={advSearch?.idc} onChange={(e) => handleChange(e)}
                                                >
                                                    <option value="">Select</option>
                                                    {countries && countries?.length > 0 && countries?.map((task, i) => {
                                                        return (
                                                            <><option key={i} value={task?.alpha3}>{task?.alpha3 + task?.countrycode}</option></>
                                                        )
                                                    }
                                                    )}
                                                </select> */}

                                            <input className="form-control contact-number" type="tel" name="phone" placeholder="Enter Phone Number"
                                                value={advSearch?.phone} onChange={(e) => handleChange(e)}
                                                maxLength="10" id="example-tel-input" />

                                            {/* </div> */}


                                        </div>
                                    </div>


                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">CREATED WITHIN</label>

                                            <select className="form-select" name="created"
                                                value={advSearch?.created} onChange={(e) => handleChange(e)}
                                            >
                                                <option value="">Select</option>
                                                <option value="lastweek">last week</option>
                                                <option value="lastmonth">last month</option>
                                                <option value="last3months">last 3 months</option>
                                                <option value="last6months">last 6 months</option>

                                            </select>

                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">ACCOUNT MANAGER </label>

                                            <select className="form-select" name="accountManager"
                                                value={advSearch?.accountManager} onChange={(e) => handleChange(e)}
                                            >
                                                <option value="">Select</option>

                                                {account?.map((item) => {
                                                    return (
                                                        <option>{item?.username}</option>
                                                    )
                                                })}
                                            </select>

                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">COMPANY NAME</label>
                                            <input name="company" placeholder=" Enter Company Name" type="text" className="form-control"
                                                value={advSearch?.company} onChange={(e) => handleChange(e)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">Conversation Status</label>

                                            <select className="form-select" name="status"
                                                value={advSearch?.status} onChange={(e) => handleChange(e)}
                                            >
                                                <option value="">Select</option>
                                                <option value="open">open</option>
                                                <option value="close">close</option>


                                            </select>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>

                            <div className="adv_footer">
                                <button className="fill_btn yellow-gradient reset-btn" onClick={handleReset}><span className="material-icons-outlined">sync</span>Reset</button>

                                <button
                                    onClick={(e) => handleSearch(e, "click")} disabled={Object.keys(advSearch).length == 0 || Object.values(advSearch).every(x => x === null || x === '')} className={(Object.keys(advSearch).length == 0 || Object.values(advSearch).every(x => x === null || x === '')) ? "disable pe-none" : loaderEnable && "pe-none"}
                                // className={`fill_btn yellow-gradient float-end ${Object.keys(searchPayload).length == 0 ? "disable" : ""}`} disabled={Object.keys(searchPayload).length == 0} 
                                >
                                    {loaderEnable ? (<img src={image + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"} className="loading-icon" />) : null}  SEARCH
                                </button>

                                <div className="clearfix"></div>
                            </div>
                        </Modal.Footer>
                    </Modal>
                    <Modal className="advance-search search-popup al_pop" show={conversationpopup} onHide={handleCloseConversation} backdrop="static">
                        <Modal.Header closeButton>
                            <Modal.Title>{conversationFormData?.conversationid ? "Update Conversation" : "Add Conversation"}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div>

                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="input-field">
                                            <label className="col-form-label">Subject</label>
                                            <span className="required">*</span>
                                            <input className="form-control" placeholder="Add Subject" type="text" name="subject"
                                                value={conversationFormData?.subject} onChange={(e) => handleConversionChange(e)}

                                                id="example-text-input" />
                                            {leadError.subject !== "" && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.subject}</span>}

                                        </div>
                                    </div>


                                    <div className="col-md-4">
                                        <div className="input-field">
                                            <label className="col-form-label">ENQUIRY DATE</label>
                                            <input id="rights1" name="enquirydate" placeholder="dd-mm-yyyy" type="date" className="form-control" value={conversationFormData?.enquirydate} onChange={(e) => handleConversionChange(e)} />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="input-field">
                                            <label className="col-form-label">CONTACT DATE</label>
                                            <span className="required">*</span>
                                            <input id="rights1" name="contactdate" placeholder="dd-mm-yyyy" type="date" className="form-control" value={conversationFormData?.contactdate} onChange={(e) => handleConversionChange(e)} />
                                            {leadError?.contactdate !== "" && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.contactdate}</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="input-field">
                                            <label className="col-form-label">Mode of communication</label>
                                            <span className="required">*</span>
                                            <select className="form-select" name="modeofcommunication" value={conversationFormData?.modeofcommunication} onChange={(e) => handleConversionChange(e)}>
                                                <option value="">Select</option>
                                                <option value="Email">Email</option>
                                                <option value="Phone">Phone</option>
                                                <option value="Messaging">Messaging</option>
                                                <option value="Video Call">Video Call</option>
                                            </select>
                                            {leadError.modeofcommunication !== "" && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.modeofcommunication}</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="input-field">
                                            <label className="col-form-label">Additional contacts</label>
                                            <CreatableSelect
                                                isMulti
                                                placeholder="Select"
                                                onChange={(e) => handleChangeMultiSelect(e, 'additionalcontacts')}
                                                options={
                                                    buyerdata?.map(item => ({
                                                        value: item?.name,
                                                        label: item?.name,
                                                    })) || []
                                                }
                                                value={conversationFormData?.additionalcontacts || []}
                                            />


                                        </div>

                                    </div>

                                    <div className="col-md-12">
                                        <div className="input-field">
                                            <label className="col-form-label">Conversation Summary</label><span className="required">*</span>
                                            <textarea id="email" placeholder="Add Summary" name="conversationsummary" type="text" className="form-control" spellcheck="true" value={conversationFormData?.conversationsummary} onChange={(e) => handleConversionChange(e)}></textarea>
                                            {leadError.conversationsummary !== "" && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.conversationsummary}</span>}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="adv_footer">

                                <button className="fill_btn yellow-gradient reset-btn" onClick={clearConversionData}><span className="material-icons-outlined" >sync</span>Reset</button>

                                <button onClick={(e) => {
                                    e.preventDefault();

                                    conversationFormData?.conversationid
                                        ? handleUpdateConversationData(saveLeadId) // ADD
                                        : handleConversationData(saveLeadId) // UPDATE
                                }} className={loaderEnable && "pe-none"}
                                // className={`fill_btn yellow-gradient float-end ${Object.keys(searchPayload).length == 0 ? "disable" : ""}`} disabled={Object.keys(searchPayload).length == 0} 
                                >
                                    {loaderEnable ? (<img src={image + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"} className="loading-icon" />) : null}  {conversationFormData?.conversationid ? " UPDATE" : "ADD"}
                                </button>

                                <div className="clearfix"></div>
                            </div>
                        </Modal.Footer>
                    </Modal>
                    <Modal className="advance-search search-popup al_pop" show={clientPopup} onHide={handleCloseClient} backdrop="static">
                        <Modal.Header closeButton>
                            <Modal.Title>Add Client</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">Client Type</label><span className="required">*</span>

                                            <select className="form-select" name="type" value={addClientData?.type} onChange={(e) => handleClientChange(e)}


                                            >
                                                <option value="">Select</option>
                                                <option value="BUYER">BUYER</option>
                                                <option value="SELLER">SELLER</option>
                                                <option value="BOTH">BOTH</option>

                                            </select>
                                            {leadError.type !== "" && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.type}</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">ENTITY</label><span className="required">*</span>

                                            <select className="form-select" value={addClientData?.entity} name="entity" onChange={(e) => handleClientChange(e)}

                                            >
                                                <option value="">select entity</option>
                                                <option value="INDIVIDUAL">INDIVIDUAL</option>
                                                <option value="COMPANY">COMPANY</option>

                                            </select>
                                            {leadError?.entity !== "" && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.entity}</span>}
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div className="input-field">
                                            <label className="col-form-label">Company</label><span className="required">*</span>
                                            {addClientData?.entity === "INDIVIDUAL" || addClientData?.entity === "" ? <input className="form-control contact-number" name="companyname" type="text" placeholder="Enter Company Name" value={addClientData.companyname} onChange={(e) => handleClientChange(e)}

                                                id="example-email-input" /> : <CreatableSelect isMulti={false}
                                                    classNamePrefix="select category"
                                                    placeholder='Company Name'
                                                    name="companyname"
                                                    onFocus={handleRemoveCompanyError}
                                                    onChange={(e) => handleChangeCompanySelect(e)}
                                                    options={company && company.map((eachItem) => { return { value: eachItem.companyname, label: eachItem.companyname } })}
                                                    value={addClientData && addClientData?.companyname && addClientData?.companyname.length > 0 ? content?.companyname?.map((eachItem) => { return { value: eachItem, label: eachItem } }) : []}
                                            />}


                                            {leadError.company !== "" && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.companyname}</span>}


                                        </div>
                                    </div>



                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="adv_footer">

                                <button className="fill_btn yellow-gradient reset-btn" onClick={clearClientData}><span className="material-icons-outlined">sync</span>Reset</button>

                                <button onClick={() => handleClientAdd("update")}
                                // className={`fill_btn yellow-gradient float-end ${Object.keys(searchPayload).length == 0 ? "disable" : ""}`} disabled={Object.keys(searchPayload).length == 0} 
                                >
                                    {loaderEnable ? (<img src={image + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"} className="loading-icon" />) : null}   ADD
                                </button>

                                <div className="clearfix"></div>
                            </div>
                        </Modal.Footer>
                    </Modal>

                    <Modal className="advance-search search-popup al_pop notify_admin" show={adminPopup} onHide={handleCloseAdminPopup} backdrop="static">
                        <Modal.Header closeButton>
                            <Modal.Title>NOTIFY ADMIN</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div>

                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="input-field">
                                            <label className="col-form-label">Company Name</label><span className="required">*</span>

                                            <input className="form-control" placeholder="Enter Company Name" type="text" name="companyname" disabled={leadData?.companyname?.[0]?.length > 0}
                                                value={notifyData?.companyname} onChange={(e) => handleChangeNotifyData(e)}
                                                id="example-text-input" />
                                            {leadError?.companyname && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.companyname}</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">Contact type</label> <span className="required">*</span>
                                            <select className="form-select" name="clienttype" value={notifyData?.contenttype} onChange={(e) => handleChangeNotifyData(e)}>
                                                <option value="">Select Contact Type</option>
                                                <option>OWNER</option>
                                                <option>DISTRIBUTOR</option>
                                                <option>OWNER & DISTRIBUTOR</option>
                                                <option>BUYER</option>
                                                <option>AGENT</option>
                                                <option>OTHER</option>
                                            </select>
                                            {leadError?.clienttype && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.clienttype}</span>}

                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">Company type</label><span className="required">*</span>
                                            <select className="form-select" name="companytype" value={notifyData?.companytype} onChange={(e) => handleChangeNotifyData(e)}>
                                                <option value="">Select</option>

                                                <option >OFFLINE</option>
                                                <option >ONLINE</option>

                                            </select>
                                            {leadError?.companytype && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.companytype}</span>}

                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">account manager Name</label><span className="required">*</span>
                                            <span className="required">*</span>
                                            <input className="form-control contact-number" disabled name="accountmanager" type="text" placeholder="Enter Account Manager Name"
                                                value={userData?.name}
                                                id="example-email-input" />

                                            {leadError?.accountmanager && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.accountmanager}</span>}

                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">Entity</label><span className="required">*</span>
                                            <select className="form-select" name="entity" value={notifyData?.entity} onChange={(e) => handleChangeNotifyData(e)} >
                                                <option value="">Select</option>

                                                <option>COMPANY</option>
                                                <option>INDIVIDUAL</option>

                                            </select>
                                            {leadError?.entity && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.entity}</span>}
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <div className="mt-2">
                                            <label className="col-form-label">agreement signed</label>
                                            <div className="input-field switch-buttons d-flex align-items-center">
                                                <label className="switch disable">
                                                    <input type="checkbox" name="agreement" checked={notifyData?.agreement} onChange={(e) => handleChangeNotifyData(e)} />
                                                    <span class="slider round"></span>
                                                </label>
                                                <label className="col-form-label">yes</label></div>
                                        </div>
                                        <div className="mt-2">
                                            <label className="col-form-label">nda signed</label>
                                            <div className="input-field switch-buttons d-flex align-items-center">
                                                <label className="switch disable">
                                                    <input type="checkbox" name="signednda" checked={notifyData?.signednda} onChange={(e) => handleChangeNotifyData(e)} />
                                                    <span class="slider round"></span>
                                                </label>
                                                <label className="col-form-label">yes</label></div>
                                        </div>
                                        <div className="mt-2 commission_details">
                                            <label className="col-form-label">commission type</label>

                                            <div className="d-flex">
                                                <div className="font-size-16">
                                                    <input type="radio" id="html" name="commissiontype" checked={notifyData?.commissiontype === 'FIXED'} value="FIXED" onChange={(e) => handleChangeNotifyData(e)} />
                                                    <label className="col-form-label">fixed</label>
                                                </div>
                                                <div className="font-size-16">
                                                    <input type="radio" id="html" name="commissiontype" checked={notifyData?.commissiontype === 'VARIABLE'} value="VARIABLE" onChange={(e) => handleChangeNotifyData(e)} />
                                                    <label className="col-form-label">Variable</label>
                                                </div>


                                            </div>

                                        </div>
                                        <div className="mt-2 percentage">
                                            <label className="col-form-label">commission percentage</label>

                                            <input type="tel" className="form-control" value={notifyData?.commissionpercentage} name="commissionpercentage" id="myPercent" onChange={(e) => {



                                                handleChangeNotifyData(e);
                                            }} />
                                            <span className="material-symbols-outlined">percent</span>

                                        </div>
                                    </div>





                                </div>
                            </div>
                        </Modal.Body>
                        {/* <Modal.Body className="border-top">
                             <div>
                                 <div className="row">
                                     <div className="col-md-12">
                                         <div className="input-field">
                                             <label className="col-form-label">Contact Classification</label> <span className="required">*</span>
                                             <select className="form-select" name="leadclassification" value={leadsFormData?.leadclassification} onChange={(e) => handleLeadChange(e)}>
                                                 <option value="">Select</option>
 
                                                 <option value="Awareness">Awareness</option>
                                                 <option value="Interest">Interest</option>
                                                 <option value="Desire">Desire</option>
                                                 <option value="Confirmation">Confirmation</option>
                                                 <option value="Conversion">Conversion</option>
                                             </select>
                                             {leadError?.leadclassification && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{leadError?.leadclassification}</span>}
 
                                         </div>
                                     </div>
 
 
                                 </div>
                             </div>
                         </Modal.Body> */}
                        <Modal.Footer>
                            <div className="adv_footer">

                                <button className="fill_btn yellow-gradient reset-btn" onClick={clearNotifyData}><span className="material-icons-outlined">sync</span>Reset</button>

                                <button onClick={(e) => handleClickSendEmail(e)} className={btnLoader === "send" && "pe-none"}
                                // className={`fill_btn yellow-gradient float-end ${Object.keys(searchPayload).length == 0 ? "disable" : ""}`} disabled={Object.keys(searchPayload).length == 0} 
                                >
                                    {btnLoader === "send" ? (<img src={image + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"} className="loading-icon" />) : null}   SEND EMAIL
                                </button>

                                <div className="clearfix"></div>
                            </div>
                        </Modal.Footer>
                    </Modal>
                    <Footer />
                    <ToastContainer />
                </div >

            </div >
        </>
    );
};

export default AllLeads;

